export default

   {
      "version": "2.4",
      "error_list": [
      {
      "code": -1,
      "code_des": "通用描述码。如果前端在本错误码库中找不到对应的code，可以直接使用-1对应的错误描述；",
      "err_msg_cn": "遇到一个未知错误",
      "err_msg_tc": "",
      "err_msg_en": "Unknown error"
      },
      {
      "code": 0,
      "code_des": "success",
      "err_msg_cn": "成功",
      "err_msg_tc": "",
      "err_msg_en": "Succeed"
      },
      {
      "code": 58,
      "code_des": "超过规定的最大（在线用户）数",
      "err_msg_cn": "在线设备已超过最大连接数",
      "err_msg_tc": "已超過最大連接數",
      "err_msg_en": "Users connections reach to limit"
      },
      {
      "code": 60,
      "code_des": "设备初始化中，请稍候。。。",
      "err_msg_cn": "设备初始化中，请稍候…",
      "err_msg_tc": "",
      "err_msg_en": "The deivce is not available now,please contact your system admin user."
      },
      {
      "code": 61,
      "code_des": "用户名不合法",
      "err_msg_cn": "非法用户名，请检查后重试",
      "err_msg_tc": "",
      "err_msg_en": "Invalid username"
      },
      {
      "code": 63,
      "code_des": "设备初始化中，请稍候。。。",
      "err_msg_cn": "系统初始化未完成，请检查设备重试",
      "err_msg_tc": "",
      "err_msg_en": "System initialization is not complete, please check and try again."
      },
      {
      "code": 10000,
      "code_des": "鉴权token失败",
      "err_msg_cn": "鉴权token失败",
      "err_msg_tc": "",
      "err_msg_en": "Token authentic failed"
      },
      {
      "code": 10001,
      "code_des": "设备未绑定",
      "err_msg_cn": "设备未绑定",
      "err_msg_tc": "",
      "err_msg_en": "Device unbound"
      },
      {
      "code": 10003,
      "code_des": "没有登录",
      "err_msg_cn": "账号未登录",
      "err_msg_tc": "",
      "err_msg_en": "Not log in"
      },
      {
      "code": 10004,
      "code_des": "内部错误",
      "err_msg_cn": "内部错误",
      "err_msg_tc": "",
      "err_msg_en": "Internal error"
      },
      {
      "code": 10007,
      "code_des": "网络已断开",
      "err_msg_cn": "网络断开",
      "err_msg_tc": "",
      "err_msg_en": "network is disconnected"
      },
      {
      "code": 10009,
      "code_des": "云账号绑定/解绑失败",
      "err_msg_cn": "校验设备连接信息异常",
      "err_msg_tc": "",
      "err_msg_en": "check bind code error"
      },
      {
      "code": 10010,
      "code_des": "存在的用户",
      "err_msg_cn": "已存在的用户",
      "err_msg_tc": "",
      "err_msg_en": "Existing user"
      },
      {
      "code": 10011,
      "code_des": "没有注册的用户",
      "err_msg_cn": "账号或密码错误",
      "err_msg_tc": "",
      "err_msg_en": "Incorrect account or password "
      },
      {
      "code": 10012,
      "code_des": "冲突错误码：\n服务端：密码错误；\n设备端：获取设备远程连接信息异常；",
      "err_msg_cn": "账号或密码错误",
      "err_msg_tc": "",
      "err_msg_en": "Incorrect account or password "
      },
      {
      "code": 10013,
      "code_des": "手机已被绑定或注册,已注册",
      "err_msg_cn": "手机已注册或绑定",
      "err_msg_tc": "",
      "err_msg_en": "Phone number is registered or bound"
      },
      {
      "code": 10014,
      "code_des": "邮箱已被绑定或注册",
      "err_msg_cn": "邮箱已注册或绑定",
      "err_msg_tc": "",
      "err_msg_en": "Email address is registered or bound"
      },
      {
      "code": 10015,
      "code_des": "验证码不正确",
      "err_msg_cn": "验证码错误",
      "err_msg_tc": "",
      "err_msg_en": "Verification code error"
      },
      {
      "code": 10016,
      "code_des": "验证码过期",
      "err_msg_cn": "验证码过期",
      "err_msg_tc": "",
      "err_msg_en": "Verification code expired"
      },
      {
      "code": 10017,
      "code_des": "验证码发送失败",
      "err_msg_cn": " 验证码发送失败/频繁发送",
      "err_msg_tc": "",
      "err_msg_en": "Failed to send the verification code"
      },
      {
      "code": 10018,
      "code_des": "验证码仍在有效期",
      "err_msg_cn": "验证码仍在有效期",
      "err_msg_tc": "",
      "err_msg_en": "Verification code still valid"
      },
      {
      "code": 10020,
      "code_des": "文件上传过多",
      "err_msg_cn": "文件上传过多",
      "err_msg_tc": "",
      "err_msg_en": "Excessive file upload"
      },
      {
      "code": 10021,
      "code_des": "数据过长",
      "err_msg_cn": "数据过长",
      "err_msg_tc": "",
      "err_msg_en": "Data overflow"
      },
      {
      "code": 10022,
      "code_des": "请求频繁",
      "err_msg_cn": "请求频繁",
      "err_msg_tc": "",
      "err_msg_en": "Requests too frequently"
      },
      {
      "code": 10026,
      "code_des": "查询设备状态失败",
      "err_msg_cn": "查询设备状态异常",
      "err_msg_tc": "",
      "err_msg_en": "get device status error"
      },
      {
      "code": 10028,
      "code_des": "存在一个未结束的磁盘任务（弹出、格式化、修复），请稍后再试",
      "err_msg_cn": "磁盘任务进行中，请稍后…",
      "err_msg_tc": "",
      "err_msg_en": "Disk task proceeding"
      },
      {
      "code": 10030,
      "code_des": "发送失败",
      "err_msg_cn": "发送失败",
      "err_msg_tc": "",
      "err_msg_en": "Send error"
      },
      {
      "code": 10100,
      "code_des": "无权限",
      "err_msg_cn": "登录超时，请重新登录",
      "err_msg_tc": "",
      "err_msg_en": "Time out"
      },
      {
      "code": 10103,
      "code_des": "网络超时，请稍候重试",
      "err_msg_cn": "网络超时，请稍候重试",
      "err_msg_tc": "",
      "err_msg_en": "request server timeout"
      },
      {
      "code": 10110,
      "code_des": "设置时区/时间失败",
      "err_msg_cn": "设置时区/时间失败",
      "err_msg_tc": "",
      "err_msg_en": "Time/Time zone set error"
      },
      {
      "code": 10111,
      "code_des": "获取时区/时间失败",
      "err_msg_cn": "获取时区/时间异常",
      "err_msg_tc": "",
      "err_msg_en": "Time/Time zone get error"
      },
      {
      "code": 10201,
      "code_des": "创建文件异常",
      "err_msg_cn": "创建文件失败",
      "err_msg_tc": "",
      "err_msg_en": "File creation failure"
      },
      {
      "code": 10202,
      "code_des": "文件不存在或已被删除",
      "err_msg_cn": "文件不存在或已被删除",
      "err_msg_tc": "檔案不存在或已刪除",
      "err_msg_en": "The file does not exist or has been deleted"
      },
      {
      "code": 10203,
      "code_des": "冲突错误码：\n服务端：用户空间值传入不正确或者目录不存在；\n设备端：数据加载出错",
      "err_msg_cn": "内部错误",
      "err_msg_tc": "",
      "err_msg_en": "Internal error"
      },
      {
      "code": 10204,
      "code_des": "冲突错误码:\n服务端：数据库更新失败\n设备端：新建文件夹失败",
      "err_msg_cn": "内部错误",
      "err_msg_tc": "",
      "err_msg_en": "Internal error"
      },
      {
      "code": 10208,
      "code_des": "获取上传文件信息出错",
      "err_msg_cn": "获取上传文件异常",
      "err_msg_tc": "",
      "err_msg_en": "Get info of files to be uploaded failed"
      },
      {
      "code": 10210,
      "code_des": "删除文件异常",
      "err_msg_cn": "删除文件失败",
      "err_msg_tc": "",
      "err_msg_en": "Delete file error"
      },
      {
      "code": 10211,
      "code_des": "获取磁盘信息异常",
      "err_msg_cn": "获取磁盘信息异常",
      "err_msg_tc": "",
      "err_msg_en": "Get disk info error"
      },
      {
      "code": 10217,
      "code_des": "移动文件异常",
      "err_msg_cn": "移动文件失败",
      "err_msg_tc": "",
      "err_msg_en": "Move file error"
      },
      {
      "code": 10218,
      "code_des": "目标文件已存在",
      "err_msg_cn": "文件已存在",
      "err_msg_tc": "",
      "err_msg_en": "File exist"
      },
      {
      "code": 10225,
      "code_des": "搜索失败",
      "err_msg_cn": "搜索文件失败",
      "err_msg_tc": "",
      "err_msg_en": "Search file error"
      },
      {
      "code": 10228,
      "code_des": "日期浏览获取月列表失败",
      "err_msg_cn": "日期浏览获取月份异常",
      "err_msg_tc": "",
      "err_msg_en": "Get month of date error"
      },
      {
      "code": 10231,
      "code_des": "日期浏览获取年列表失败",
      "err_msg_cn": "日期浏览获取年份异常",
      "err_msg_tc": "",
      "err_msg_en": "Get year of date error"
      },
      {
      "code": 10241,
      "code_des": "获取最近记录列表失败",
      "err_msg_cn": "数据加载出错",
      "err_msg_tc": "",
      "err_msg_en": "Data loading error"
      },
      {
      "code": 10259,
      "code_des": "fw verify error and the bin file operation error",
      "err_msg_cn": "设备系统错误",
      "err_msg_tc": "",
      "err_msg_en": "Device system error"
      },
      {
      "code": 10284,
      "code_des": "设备固件需要强制更新",
      "err_msg_cn": "设备固件强制更新",
      "err_msg_tc": "",
      "err_msg_en": "Device firmware force update"
      },
      {
      "code": 10285,
      "code_des": "设备正在更新固件",
      "err_msg_cn": "设备固件升级中",
      "err_msg_tc": "",
      "err_msg_en": "Device firmware is being update"
      },
      {
      "code": 10286,
      "code_des": "设备固件更新失败",
      "err_msg_cn": "固件升级失败，请连接设备后重试",
      "err_msg_tc": "升級失敗,請重新連接裝置後重試",
      "err_msg_en": "Upgrade failed, please reconnect the device and try again"
      },
      {
      "code": 10287,
      "code_des": "日志压缩失败",
      "err_msg_cn": "发送日志失败",
      "err_msg_tc": "",
      "err_msg_en": "Log send error"
      },
      {
      "code": 10293,
      "code_des": "删除分享失败",
      "err_msg_cn": "删除分享失败",
      "err_msg_tc": "",
      "err_msg_en": "Delete share error"
      },
      {
      "code": 10294,
      "code_des": "不支持分享",
      "err_msg_cn": "不支持分享",
      "err_msg_tc": "",
      "err_msg_en": "Not support sharing"
      },
      {
      "code": 10296,
      "code_des": "创建分享链接失败",
      "err_msg_cn": "创建分享链接失败",
      "err_msg_tc": "",
      "err_msg_en": "Create a share link error"
      },
      {
      "code": 10297,
      "code_des": "获取分享链接列表失败",
      "err_msg_cn": "获取分享链接列表异常",
      "err_msg_tc": "",
      "err_msg_en": "Get share link list error"
      },
      {
      "code": 10303,
      "code_des": "请求分享文件数据超过文件大小",
      "err_msg_cn": "请求分享文件数据超过文件大小",
      "err_msg_tc": "",
      "err_msg_en": "File to be shared exceed file size"
      },
      {
      "code": 10319,
      "code_des": "重命名的新文件名格式错误(比如.开头)",
      "err_msg_cn": "重命名的新文件名格式错误(比如.开头)",
      "err_msg_tc": "",
      "err_msg_en": "New file name by rename error"
      },
      {
      "code": 10320,
      "code_des": "新建文件夹的文件名格式错误(比如.开头)",
      "err_msg_cn": "新建文件夹的文件名格式错误(比如.开头)",
      "err_msg_tc": "",
      "err_msg_en": "New file name by create folder error"
      },
      {
      "code": 10321,
      "code_des": "获取空间列表失败",
      "err_msg_cn": "获取空间列表失败",
      "err_msg_tc": "",
      "err_msg_en": "Get space list error"
      },
      {
      "code": 10532,
      "code_des": "重启设备失败",
      "err_msg_cn": "重启设备失败",
      "err_msg_tc": "",
      "err_msg_en": "Device restart failed"
      },
      {
      "code": 10533,
      "code_des": "设备关机失败",
      "err_msg_cn": "关闭设备失败",
      "err_msg_tc": "",
      "err_msg_en": "Close device failed"
      },
      {
      "code": 10534,
      "code_des": "不能访问日志服务器",
      "err_msg_cn": "无法访问日志服务器",
      "err_msg_tc": "",
      "err_msg_en": "Cannot access log server"
      },
      {
      "code": 10535,
      "code_des": "日志大小错误",
      "err_msg_cn": "日志大小错误",
      "err_msg_tc": "",
      "err_msg_en": "Log size error"
      },
      {
      "code": 10536,
      "code_des": "日志上传错误",
      "err_msg_cn": "日志上传错误",
      "err_msg_tc": "",
      "err_msg_en": "Log upload error"
      },
      {
      "code": 13115,
      "code_des": "download des path is not exit",
      "err_msg_cn": "本地下载路径不存在",
      "err_msg_tc": "",
      "err_msg_en": "Local download path does not exist"
      },
      {
      "code": 13116,
      "code_des": "local file system operation failed",
      "err_msg_cn": "本地文件系统异常",
      "err_msg_tc": "",
      "err_msg_en": "Local file system error"
      },
      {
      "code": 18205,
      "code_des": "无效的密文数据（主要用于密码数据加密后数据检测)",
      "err_msg_cn": "无效的密文数据",
      "err_msg_tc": "",
      "err_msg_en": "Invalid ciphertext data"
      },
      {
      "code": 20000,
      "code_des": "unknow error",
      "err_msg_cn": "未知错误",
      "err_msg_tc": "",
      "err_msg_en": "Unknown error"
      },
      {
      "code": 20001,
      "code_des": "设备固件升级超时，请重新连接设备，查看升级结果",
      "err_msg_cn": "设备固件升级超时，请重连设备并查看升级结果",
      "err_msg_tc": "",
      "err_msg_en": "Firmware upgrade times out. Please connect the device again and check the upgrade result"
      },
      {
      "code": 20005,
      "code_des": "there is no disk",
      "err_msg_cn": "当前无磁盘",
      "err_msg_tc": "",
      "err_msg_en": "No disk"
      },
      {
      "code": 20006,
      "code_des": "there is no enough space",
      "err_msg_cn": "当前空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Current space shortage"
      },
      {
      "code": 20008,
      "code_des": "the task has been canceled by user",
      "err_msg_cn": "任务已被取消",
      "err_msg_tc": "",
      "err_msg_en": "Task has been cancelled"
      },
      {
      "code": 20012,
      "code_des": "禁止操作系统盘",
      "err_msg_cn": "禁止操作系统盘",
      "err_msg_tc": "",
      "err_msg_en": "Do not operate system disk"
      },
      {
      "code": 20013,
      "code_des": "修改磁盘别名失败",
      "err_msg_cn": "修改磁盘别名失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to change the name of disk"
      },
      {
      "code": 20014,
      "code_des": "磁盘空间已满",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Not enough disk space"
      },
      {
      "code": 20015,
      "code_des": "弹出磁盘失败",
      "err_msg_cn": "弹出磁盘失败",
      "err_msg_tc": "",
      "err_msg_en": "Eject disk failed"
      },
      {
      "code": 20016,
      "code_des": "设置系统盘失败",
      "err_msg_cn": "设置系统盘失败",
      "err_msg_tc": "",
      "err_msg_en": "Set the system disk failed"
      },
      {
      "code": 28000,
      "code_des": "无效消息id",
      "err_msg_cn": "无效的消息",
      "err_msg_tc": "",
      "err_msg_en": "Invalid message"
      },
      {
      "code": 28001,
      "code_des": "mqtt超时",
      "err_msg_cn": "设备请求超时",
      "err_msg_tc": "",
      "err_msg_en": "Device request timeout"
      },
      {
      "code": 28002,
      "code_des": "数据段过长",
      "err_msg_cn": "数据段过长",
      "err_msg_tc": "",
      "err_msg_en": "The data segment is too long"
      },
      {
      "code": 28003,
      "code_des": "不存在的用户",
      "err_msg_cn": "不存在的用户",
      "err_msg_tc": "",
      "err_msg_en": "The user does not exist"
      },
      {
      "code": 28004,
      "code_des": "设备不存在或未找到",
      "err_msg_cn": "设备不存在或未找到",
      "err_msg_tc": "",
      "err_msg_en": "Device does not exist or is not found"
      },
      {
      "code": 28005,
      "code_des": "连接失败",
      "err_msg_cn": "连接设备失败",
      "err_msg_tc": "",
      "err_msg_en": "Device connection failure"
      },
      {
      "code": 28006,
      "code_des": "设备不在线！",
      "err_msg_cn": "设备不在线",
      "err_msg_tc": "",
      "err_msg_en": "Device offline"
      },
      {
      "code": 28007,
      "code_des": "不存在该设备",
      "err_msg_cn": "无效的设备",
      "err_msg_tc": "",
      "err_msg_en": "Invalid equipment"
      },
      {
      "code": 28008,
      "code_des": "绑定设备失败",
      "err_msg_cn": "绑定设备失败",
      "err_msg_tc": "",
      "err_msg_en": "Device binding failure"
      },
      {
      "code": 28009,
      "code_des": "当前设备用户已被其它云帐号绑定",
      "err_msg_cn": "设备已被其它账号绑定",
      "err_msg_tc": "",
      "err_msg_en": "Device has been bound to another account"
      },
      {
      "code": 28010,
      "code_des": "更新用户信息错误",
      "err_msg_cn": "更新用户信息错误",
      "err_msg_tc": "",
      "err_msg_en": "Failed to update user information"
      },
      {
      "code": 28011,
      "code_des": "当前设备用户已被当前云帐号绑定",
      "err_msg_cn": "设备已被其它账号绑定",
      "err_msg_tc": "",
      "err_msg_en": "Device has been bound to another account"
      },
      {
      "code": 28012,
      "code_des": "无效的token",
      "err_msg_cn": "登录信息已过期，请重新登录",
      "err_msg_tc": "",
      "err_msg_en": "Login information has expired. Please log in again"
      },
      {
      "code": 28015,
      "code_des": "Token失效",
      "err_msg_cn": "云账号登录信息已过期",
      "err_msg_tc": "",
      "err_msg_en": "Login information of the cloud account has expired"
      },
      {
      "code": 28013,
      "code_des": "已过期",
      "err_msg_cn": "已过期",
      "err_msg_tc": "",
      "err_msg_en": "Expired"
      },
      {
      "code": 28014,
      "code_des": "无效的appid",
      "err_msg_cn": "无效的appid",
      "err_msg_tc": "",
      "err_msg_en": "Invalid appid"
      },
      {
      "code": 28016,
      "code_des": "无效参数",
      "err_msg_cn": "无效的参数",
      "err_msg_tc": "",
      "err_msg_en": "Invalid parameter"
      },
      {
      "code": 28017,
      "code_des": "已经授权过",
      "err_msg_cn": "已经授权过",
      "err_msg_tc": "",
      "err_msg_en": "Authorized"
      },
      {
      "code": 28018,
      "code_des": "邀请码不正确(邀请绑定的邀请码)",
      "err_msg_cn": "邀请码不正确(邀请绑定的邀请码)",
      "err_msg_tc": "",
      "err_msg_en": "The bound invitation code incorrect"
      },
      {
      "code": 28019,
      "code_des": "邀请码已过期(邀请绑定的邀请码)",
      "err_msg_cn": "邀请码已过期(邀请绑定的邀请码)",
      "err_msg_tc": "",
      "err_msg_en": "The bound invitation code expired"
      },
      {
      "code": 28020,
      "code_des": "Mqtt31开始的错误code",
      "err_msg_cn": "设备异常",
      "err_msg_tc": "",
      "err_msg_en": "device abnormal"
      },
      {
      "code": 28021,
      "code_des": "邀请绑定记录信息不存在",
      "err_msg_cn": "邀请绑定信息不存在",
      "err_msg_tc": "",
      "err_msg_en": "Invitation binding information does not exist"
      },
      {
      "code": 28022,
      "code_des": "邀请绑定记录信息已过期",
      "err_msg_cn": "邀请绑定信息已过期",
      "err_msg_tc": "",
      "err_msg_en": "Invitation binding information expired"
      },
      {
      "code": 28023,
      "code_des": "免密登录关联信息不存在",
      "err_msg_cn": "免密登录关联信息不存在",
      "err_msg_tc": "",
      "err_msg_en": "The password-free login association does not exist"
      },
      {
      "code": 28024,
      "code_des": "免密登录关联信息已过期",
      "err_msg_cn": "免密登录关联信息已过期",
      "err_msg_tc": "",
      "err_msg_en": "The password-free login association expired"
      },
      {
      "code": 28025,
      "code_des": "二维码ID无效或已过期",
      "err_msg_cn": "二维码无效或已过期",
      "err_msg_tc": "",
      "err_msg_en": "The QR code is invalid or expired"
      },
      {
      "code": 28026,
      "code_des": "云账号登录失败",
      "err_msg_cn": "云账号登录失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to log in to the cloud account"
      },
      {
      "code": 28030,
      "code_des": "没有找到/目标不存在",
      "err_msg_cn": "没有找到/目标不存在",
      "err_msg_tc": "",
      "err_msg_en": "Target does not exist"
      },
      {
      "code": 28031,
      "code_des": "邀请码已被使用",
      "err_msg_cn": "邀请码已被使用",
      "err_msg_tc": "",
      "err_msg_en": "Invitation code has been used"
      },
      {
      "code": 28050,
      "code_des": "未出库",
      "err_msg_cn": "未出库",
      "err_msg_tc": "",
      "err_msg_en": "Still in the data base"
      },
      {
      "code": 28051,
      "code_des": "设备远程地址未分配",
      "err_msg_cn": "设备远程地址未分配",
      "err_msg_tc": "",
      "err_msg_en": "Remote address of the device is not assigned"
      },
      {
      "code": 28060,
      "code_des": "废弃的功能",
      "err_msg_cn": "废弃的功能",
      "err_msg_tc": "",
      "err_msg_en": "Obsolete function"
      },
      {
      "code": 28070,
      "code_des": "授权UUID额度不够",
      "err_msg_cn": "授权UUID额度不够",
      "err_msg_tc": "",
      "err_msg_en": "Authorized UUID quota is insufficient"
      },
      {
      "code": 28100,
      "code_des": "不支持的操作,人脸识别用的",
      "err_msg_cn": "不支持的操作",
      "err_msg_tc": "",
      "err_msg_en": "Unsupported operations"
      },
      {
      "code": 28201,
      "code_des": " 添加权限记录或更新权限记录前名称已存在",
      "err_msg_cn": "添加权限记录或更新权限记录前名称已存在",
      "err_msg_tc": "",
      "err_msg_en": "The name already existed before the permission record was added or updated"
      },
      {
      "code": 28202,
      "code_des": " 添加记录时父节点不存在",
      "err_msg_cn": "添加记录时父节点不存在",
      "err_msg_tc": "",
      "err_msg_en": "The parent node does not exist when a record is added"
      },
      {
      "code": 28203,
      "code_des": " 需要更新的ID不存在",
      "err_msg_cn": "需要更新的ID不存在",
      "err_msg_tc": "",
      "err_msg_en": "The ID to be updated does not exist"
      },
      {
      "code": 28204,
      "code_des": " 添加角色记录或更新角色记录前名称已存在",
      "err_msg_cn": "添加角色记录或更新角色记录前名称已存在",
      "err_msg_tc": "",
      "err_msg_en": "The name already existed before the role record was added or updated"
      },
      {
      "code": 28205,
      "code_des": " 角色ID不存在",
      "err_msg_cn": "角色ID不存在",
      "err_msg_tc": "",
      "err_msg_en": "The role ID does not exist"
      },
      {
      "code": 28206,
      "code_des": " 后台管理系统用户不存在（如：通过adminId查用户信息未找到）",
      "err_msg_cn": "后台管理系统用户不存在（如：通过adminId查用户信息未找到）",
      "err_msg_tc": "",
      "err_msg_en": "The background management system user does not exist"
      },
      {
      "code": 28207,
      "code_des": " 无接口调用权限",
      "err_msg_cn": "无接口调用权限",
      "err_msg_tc": "",
      "err_msg_en": "No interface invocation permission"
      },
      {
      "code": 28208,
      "code_des": " 二维码下载查询时对应的标识符不存在",
      "err_msg_cn": "二维码下载查询时对应的标识符不存在",
      "err_msg_tc": "",
      "err_msg_en": "The corresponding identifier does not exist when the QR code is queried"
      },
      {
      "code": 29999,
      "code_des": "未知错误 其他错误",
      "err_msg_cn": "未知或其他错误",
      "err_msg_tc": "",
      "err_msg_en": "Unknown or other errors"
      },
      {
      "code": 30000,
      "code_des": "the device is not ready",
      "err_msg_cn": "设备初始化中，请稍候…",
      "err_msg_tc": "",
      "err_msg_en": "Device initialization, please wait…"
      },
      {
      "code": 30001,
      "code_des": "disk health is not pass",
      "err_msg_cn": "磁盘健康不达标",
      "err_msg_tc": "",
      "err_msg_en": "The disk health does not meet the standard"
      },
      {
      "code": 30002,
      "code_des": "",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient disk space"
      },
      {
      "code": 30003,
      "code_des": " disk health is not pass when initing",
      "err_msg_cn": "磁盘初始化时，健康值不达标",
      "err_msg_tc": "",
      "err_msg_en": "The health value did not reach the standard during disk initialization"
      },
      {
      "code": 30005,
      "code_des": " 系统盘掉了",
      "err_msg_cn": "磁盘掉盘了，请将设备重新启动",
      "err_msg_tc": "",
      "err_msg_en": "Disk dropped. Please restart the device"
      },
      {
      "code": 30006,
      "code_des": "系统盘未挂载",
      "err_msg_cn": "系统盘未挂载",
      "err_msg_tc": "",
      "err_msg_en": "The system disk is not mounted"
      },
      {
      "code": 30007,
      "code_des": "系统盘未设置",
      "err_msg_cn": "系统盘未设置，请设置后体验",
      "err_msg_tc": "",
      "err_msg_en": "The system disk is not set. Set and try it later"
      },
      {
      "code": 30008,
      "code_des": "系统盘只读了",
      "err_msg_cn": "系统盘只读了，请将磁盘插入PC进行修复后重试",
      "err_msg_tc": "系統盤只讀了，請將磁盤插入PC進行修復後重試",
      "err_msg_en": "The system disk is read-only. Please insert the disk into the PC for repair and try again"
      },
      {
      "code": 30009,
      "code_des": "系统盘未知错误",
      "err_msg_cn": "系统盘异常，请检查磁盘后重启设备",
      "err_msg_tc": "系統盤異常，請檢查磁盤後重啟设备",
      "err_msg_en": "The Disk is Error % s, please check the disk, restart and try again"
      },
      {
      "code": 30010,
      "code_des": "系统盘已设置并正确挂载，不允许重设系统盘",
      "err_msg_cn": "系统盘已设置并正确挂载，不允许重设系统盘",
      "err_msg_tc": "",
      "err_msg_en": "The system disk is configured and mounted correctly. Resetting the system disk is not allowed"
      },
      {
      "code": 30011,
      "code_des": "设备端免密登录凭证的解密秘钥与服务器不同步",
      "err_msg_cn": "设备端免密登录凭证的解密秘钥与服务器不同步",
      "err_msg_tc": "",
      "err_msg_en": "The decryption key of the password-free login certificate on the device is different with that on the server"
      },
      {
      "code": 30012,
      "code_des": "设备未绑定,不支持web登录/分享等相关功能",
      "err_msg_cn": "设备未绑定，操作失败",
      "err_msg_tc": "",
      "err_msg_en": "The operation failed because the device is not bound"
      },
      {
      "code": 30014,
      "code_des": "云账号已绑定其它本地用户",
      "err_msg_cn": "该账号已绑定其他用户",
      "err_msg_tc": "",
      "err_msg_en": "The account has been bound to another user"
      },
      {
      "code": 30015,
      "code_des": "本地用户已绑定到其它云账号",
      "err_msg_cn": "该用户已绑定其他账号",
      "err_msg_tc": "",
      "err_msg_en": "The user has been bound to another account"
      },
      {
      "code": 40001,
      "code_des": "存储空间不足",
      "err_msg_cn": "存储空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient storage space"
      },
      {
      "code": 40002,
      "code_des": "磁盘未挂载",
      "err_msg_cn": "磁盘未挂载",
      "err_msg_tc": "",
      "err_msg_en": "The disk is not mounted"
      },
      {
      "code": 40003,
      "code_des": "系统内存不足",
      "err_msg_cn": "系统内存不足",
      "err_msg_tc": "",
      "err_msg_en": "Out of system memory"
      },
      {
      "code": 40004,
      "code_des": "不支持的操作",
      "err_msg_cn": "分享文件的设备不支持保存",
      "err_msg_tc": "",
      "err_msg_en": "The device that shares the file do not support save"
      },
      {
      "code": 40006,
      "code_des": "设备不支持视频转码率",
      "err_msg_cn": "设备不支持视频转码率",
      "err_msg_tc": "",
      "err_msg_en": "The device does not support video transrate"
      },
      {
      "code": 41001,
      "code_des": "No such file or directory was not found",
      "err_msg_cn": "分享文件已被删除",
      "err_msg_tc": "",
      "err_msg_en": "The shared file has been deleted"
      },
      {
      "code": 41050,
      "code_des": "No such shareId was found",
      "err_msg_cn": "分享文件或链接不存在了",
      "err_msg_tc": "",
      "err_msg_en": "The shared file or link does not exist"
      },
      {
      "code": 41051,
      "code_des": "分享失效",
      "err_msg_cn": "分享失效",
      "err_msg_tc": "",
      "err_msg_en": "Sharing failure"
      },
      {
      "code": 41052,
      "code_des": "分享用户的下载流量已用完",
      "err_msg_cn": "当月流量已用完，文件暂无法打开",
      "err_msg_tc": "",
      "err_msg_en": "Flow ran out, the file cannot be opened"
      },
      {
      "code": 41053,
      "code_des": " Share is too many",
      "err_msg_cn": "当前用户创建的分享链接已超过最大数",
      "err_msg_tc": "",
      "err_msg_en": "The number of share links created by the current user has exceeded the upper limit"
      },
      {
      "code": 41054,
      "code_des": "分享登陆失效",
      "err_msg_cn": "分享登录失效",
      "err_msg_tc": "",
      "err_msg_en": "Share login failure"
      },
      {
      "code": 41055,
      "code_des": "链接被举报含有非法内容，访问已失效。",
      "err_msg_cn": "链接被举报含有非法内容，访问已失效。",
      "err_msg_tc": "",
      "err_msg_en": "Link reported to contain illegal content, access is invalid."
      },
      {
      "code": 41056,
      "code_des": "打开文件失败",
      "err_msg_cn": "打开文件失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to open file"
      },
      {
      "code": 41057,
      "code_des": "关闭文件失败",
      "err_msg_cn": "关闭文件失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to close file"
      },
      {
      "code": 41059,
      "code_des": "任务保存失败",
      "err_msg_cn": "任务保存失败",
      "err_msg_tc": "",
      "err_msg_en": "Task saving failure"
      },
      {
      "code": 41060,
      "code_des": "冲突错误码：\n服务端：已举报过；\n设备端：创建文件夹失败;",
      "err_msg_cn": "内部错误",
      "err_msg_tc": "",
      "err_msg_en": " Internal error"
      },
      {
      "code": 41061,
      "code_des": "文件大小超出文件系统限制",
      "err_msg_cn": "文件大小超出系统限制",
      "err_msg_tc": "",
      "err_msg_en": "The file size exceeds the system limit"
      },
      {
      "code": 41062,
      "code_des": "文件夹不存在，移动和复制操作 ",
      "err_msg_cn": "文件夹不存在，移动和复制操作失败",
      "err_msg_tc": "",
      "err_msg_en": "The folder does not exist. The move and copy operation failed"
      },
      {
      "code": 41063,
      "code_des": "禁止的文件操作",
      "err_msg_cn": "禁止的文件操作",
      "err_msg_tc": "",
      "err_msg_en": "Forbidden file operation"
      },
      {
      "code": 41064,
      "code_des": "主机文件读取失败",
      "err_msg_cn": "文件读取失败",
      "err_msg_tc": "",
      "err_msg_en": "File reading failure"
      },
      {
      "code": 41066,
      "code_des": "主机文件读取失败",
      "err_msg_cn": "文件读取失败",
      "err_msg_tc": "",
      "err_msg_en": "File reading failure"
      },
      {
      "code": 41067,
      "code_des": "任务队列已满",
      "err_msg_cn": "任务队列已满",
      "err_msg_tc": "",
      "err_msg_en": "The task queue is full"
      },
      {
      "code": 41068,
      "code_des": "获取展示路径失败",
      "err_msg_cn": "获取展示路径失败",
      "err_msg_tc": "",
      "err_msg_en": "Get display path failed"
      },
      {
      "code": 41069,
      "code_des": "文件重命名失败",
      "err_msg_cn": "文件重命名失败",
      "err_msg_tc": "",
      "err_msg_en": "Rename failed"
      },
      {
      "code": 41071,
      "code_des": "分享的文件过多",
      "err_msg_cn": "下载文件数量超过2000，请删减后重试",
      "err_msg_tc": "",
      "err_msg_en": "Downloaded files exceed 2000, delete them and try again"
      },
      {
      "code": 41072,
      "code_des": "冲突错误码：\n服务端：分享的文件过大；\n设备端：磁盘异常；",
      "err_msg_cn": "分享的文件过大",
      "err_msg_tc": "",
      "err_msg_en": "The file being shared is too large"
      },
      {
      "code": 41073,
      "code_des": "单个文件过大",
      "err_msg_cn": "单个文件过大",
      "err_msg_tc": "",
      "err_msg_en": "Single file too large"
      },
      {
      "code": 41080,
      "code_des": "至少包含一个人脸",
      "err_msg_cn": "至少包含一个人脸",
      "err_msg_tc": "",
      "err_msg_en": "Contains at least one human face"
      },
      {
      "code": 42001,
      "code_des": "设备不支持视频转码率",
      "err_msg_cn": "设备不支持视频转码率",
      "err_msg_tc": "",
      "err_msg_en": "The device does not support video transrate"
      },
      {
      "code": 49999,
      "code_des": "未知错误(人脸识别)",
      "err_msg_cn": "未知错误(人脸识别)",
      "err_msg_tc": "",
      "err_msg_en": "Unknown error (face recognition)"
      },
      {
      "code": 50000,
      "code_des": "ErrSessionTimeout session超时",
      "err_msg_cn": "ErrSessionTimeout session超时　",
      "err_msg_tc": "",
      "err_msg_en": "Err SessionTimeout"
      },
      {
      "code": 50001,
      "code_des": "ErrOccupied 资源被占用",
      "err_msg_cn": "ErrOccupied 资源被占用",
      "err_msg_tc": "",
      "err_msg_en": "Err Occupied"
      },
      {
      "code": 50002,
      "code_des": "ErrUnsupportedMediaType 不支持的类型",
      "err_msg_cn": "ErrUnsupportedMediaType 不支持的类型",
      "err_msg_tc": "",
      "err_msg_en": "Err Unsupported Media Type"
      },
      {
      "code": 50003,
      "code_des": "ErrInternalServerError 服务器内部错误5",
      "err_msg_cn": "账号或密码错误，请重新输入",
      "err_msg_tc": "",
      "err_msg_en": "The account or password is incorrect. Please re-enter it"
      },
      {
      "code": 60001,
      "code_des": "文件分块已经传输完成",
      "err_msg_cn": "文件分块已经传输完成",
      "err_msg_tc": "",
      "err_msg_en": "The file block has been transferred"
      },
      {
      "code": 80002,
      "code_des": "redis错误",
      "err_msg_cn": "redis错误",
      "err_msg_tc": "",
      "err_msg_en": "Redis error"
      },
      {
      "code": 80100,
      "code_des": "获取云账号登录信息超时",
      "err_msg_cn": "获取云账号登录信息超时",
      "err_msg_tc": "",
      "err_msg_en": "Get cloud account login information times out"
      },
      {
      "code": 80101,
      "code_des": "共享组名重复",
      "err_msg_cn": "共享组名称重复",
      "err_msg_tc": "",
      "err_msg_en": "The share group name is the same"
      },
      {
      "code": 80102,
      "code_des": "用户中心返回错误",
      "err_msg_cn": "用户中心返回失败",
      "err_msg_tc": "",
      "err_msg_en": "The user center failed to return"
      },
      {
      "code": 80103,
      "code_des": "设备未绑定，暂时无法使用该功能",
      "err_msg_cn": "设备未绑定，暂时无法使用该功能",
      "err_msg_tc": "",
      "err_msg_en": "The device is not bound and cannot use this function"
      },
      {
      "code": 80104,
      "code_des": "没权限解散共享组",
      "err_msg_cn": "没权限解散共享组",
      "err_msg_tc": "",
      "err_msg_en": "Have no permission to disband a share group"
      },
      {
      "code": 80105,
      "code_des": "共享组不存在",
      "err_msg_cn": "共享组不存在",
      "err_msg_tc": "",
      "err_msg_en": "Share group does not exist"
      },
      {
      "code": 80106,
      "code_des": "踢出共享组错误",
      "err_msg_cn": "踢出共享组失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to kick out from the share group"
      },
      {
      "code": 80107,
      "code_des": "退出共享组错误",
      "err_msg_cn": "退出共享组失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to exit the share group"
      },
      {
      "code": 80108,
      "code_des": "没权限修改共享组信息",
      "err_msg_cn": "没权限修改共享组信息",
      "err_msg_tc": "",
      "err_msg_en": "You have no permission to modify share group information"
      },
      {
      "code": 80109,
      "code_des": "没有权限获取二维码",
      "err_msg_cn": "没有权限获取二维码",
      "err_msg_tc": "",
      "err_msg_en": "No access to the QR code"
      },
      {
      "code": 80110,
      "code_des": "二维码生成失败",
      "err_msg_cn": "二维码生成失败",
      "err_msg_tc": "",
      "err_msg_en": "QR code generation failure"
      },
      {
      "code": 80111,
      "code_des": "二维码过期",
      "err_msg_cn": "当前二维码已失效，无法加入",
      "err_msg_tc": "",
      "err_msg_en": "The current QR code is invalid, cannot join"
      },
      {
      "code": 80112,
      "code_des": "重复加入",
      "err_msg_cn": "重复加入",
      "err_msg_tc": "",
      "err_msg_en": "Repetitive join"
      },
      {
      "code": 80113,
      "code_des": "当前共享组人员已满，无法加入",
      "err_msg_cn": "当前共享组人员已满，无法加入",
      "err_msg_tc": "",
      "err_msg_en": "The current share group is full and cannot join"
      },
      {
      "code": 80114,
      "code_des": "无权限获取共享组成员",
      "err_msg_cn": "无权限获取共享组成员　",
      "err_msg_tc": "",
      "err_msg_en": "No permission to obtain a share group member"
      },
      {
      "code": 80115,
      "code_des": "创建共享组已达上限",
      "err_msg_cn": "创建共享组已达上限",
      "err_msg_tc": "",
      "err_msg_en": "The number of creating share groups has reached the upper limit"
      },
      {
      "code": 80116,
      "code_des": "当前二维码已失效，无法加入",
      "err_msg_cn": "当前二维码已失效，无法加入",
      "err_msg_tc": "",
      "err_msg_en": "The current QR code is invalid, cannot join"
      },
      {
      "code": 80117,
      "code_des": "非共享组成员",
      "err_msg_cn": "非共享组成员",
      "err_msg_tc": "",
      "err_msg_en": "Not a member of the shared group"
      },
      {
      "code": 80118,
      "code_des": "未查询到数据",
      "err_msg_cn": "未查询到数据",
      "err_msg_tc": "",
      "err_msg_en": "No data is queried"
      },
      {
      "code": 80119,
      "code_des": "展示类型错误，无缩略图",
      "err_msg_cn": "展示类型错误，无缩略图",
      "err_msg_tc": "",
      "err_msg_en": "Incorrect display type, no thumbnail"
      },
      {
      "code": 80120,
      "code_des": "未找到分享文件",
      "err_msg_cn": "未找到分享文件",
      "err_msg_tc": "",
      "err_msg_en": "No shared file found"
      },
      {
      "code": 80121,
      "code_des": "下载文件数量超出限制",
      "err_msg_cn": "下载文件数量超出限制",
      "err_msg_tc": "",
      "err_msg_en": "The number of downloaded files exceeds the limit"
      },
      {
      "code": 80122,
      "code_des": "无权删除分享项",
      "err_msg_cn": "无权删除分享项",
      "err_msg_tc": "",
      "err_msg_en": "The shared item has no right to delete"
      },
      {
      "code": 80123,
      "code_des": "无权限下载文件",
      "err_msg_cn": "无权限下载文件",
      "err_msg_tc": "",
      "err_msg_en": "No permission to download files"
      },
      {
      "code": 80124,
      "code_des": "没有保存权限",
      "err_msg_cn": "没有保存权限",
      "err_msg_tc": "",
      "err_msg_en": "No save permission"
      },
      {
      "code": 80125,
      "code_des": "被访问者非共享组成员",
      "err_msg_cn": "被访问者非共享组成员",
      "err_msg_tc": "",
      "err_msg_en": "Interviewee is not a member of the shared group"
      },
      {
      "code": 80126,
      "code_des": "未查询到数据",
      "err_msg_cn": "未查询到数据",
      "err_msg_tc": "",
      "err_msg_en": "No data is queried"
      },
      {
      "code": 80127,
      "code_des": "未查询到数据",
      "err_msg_cn": "未查询到数据",
      "err_msg_tc": "",
      "err_msg_en": "No data is queried"
      },
      {
      "code": 80128,
      "code_des": "文件不可在同设备内下载",
      "err_msg_cn": "文件不可在同设备内下载",
      "err_msg_tc": "",
      "err_msg_en": "Files cannot be downloaded on the same device"
      },
      {
      "code": 80129,
      "code_des": "没有权限获取共享组邀请权限",
      "err_msg_cn": "没有权限获取共享组邀请权限",
      "err_msg_tc": "",
      "err_msg_en": "No permission to obtain the share group invitation"
      },
      {
      "code": 80130,
      "code_des": "邀请失效或过期",
      "err_msg_cn": "邀请失效或过期",
      "err_msg_tc": "",
      "err_msg_en": "The invitation is invalid or expired"
      },
      {
      "code": 80200,
      "code_des": "云账号已经绑定了微信号",
      "err_msg_cn": "账号已绑定微信号",
      "err_msg_tc": "",
      "err_msg_en": "The account has been bound with wechat"
      },
      {
      "code": 80201,
      "code_des": "微信号已经绑定了其他云账号",
      "err_msg_cn": "微信号已绑定其他账号",
      "err_msg_tc": "",
      "err_msg_en": "The wechat account has been bound to another account"
      },
      {
      "code": 80202,
      "code_des": "state值过期或输入错误",
      "err_msg_cn": "state值过期或输入错误",
      "err_msg_tc": "",
      "err_msg_en": "The state value is expired or incorrect"
      },
      {
      "code": 80300,
      "code_des": "云账号已经绑定了加密狗",
      "err_msg_cn": "账号已绑定加密狗",
      "err_msg_tc": "",
      "err_msg_en": "The account has been bound to encrypted dog"
      },
      {
      "code": 80301,
      "code_des": "加密狗已经绑定了云账号",
      "err_msg_cn": "加密狗已绑定账号",
      "err_msg_tc": "",
      "err_msg_en": "Encrypted dog has been bound to an account"
      },
      {
      "code": 80302,
      "code_des": "云账号没绑定加密狗",
      "err_msg_cn": "账号未绑定加密狗",
      "err_msg_tc": "",
      "err_msg_en": "The account do not bound to encrypted dog"
      },
      {
      "code": 80303,
      "code_des": "云账号没绑定加密狗",
      "err_msg_cn": "账号未绑定加密狗",
      "err_msg_tc": "",
      "err_msg_en": "The account do not bound to encrypted dog"
      },
      {
      "code": 80304,
      "code_des": "safe code 输入错误",
      "err_msg_cn": "safe code输入错误",
      "err_msg_tc": "",
      "err_msg_en": "The safe code is incorrect"
      },
      {
      "code": 80305,
      "code_des": "随机码输入错误",
      "err_msg_cn": "随机码输入错误",
      "err_msg_tc": "",
      "err_msg_en": "Random code input error"
      },
      {
      "code": 80306,
      "code_des": "该用户未创建filedog",
      "err_msg_cn": "该用户未创建filedog",
      "err_msg_tc": "",
      "err_msg_en": "The user does not create a filedog"
      },
      {
      "code": 80307,
      "code_des": "该用户未创建filedog",
      "err_msg_cn": "该用户未创建filedog",
      "err_msg_tc": "",
      "err_msg_en": "The user does not create a filedog"
      },
      {
      "code": 80308,
      "code_des": "随机码输入错误或超时",
      "err_msg_cn": "随机码输入错误或超时",
      "err_msg_tc": "",
      "err_msg_en": "Random code input error or timeout"
      },
      {
      "code": 80309,
      "code_des": "安全码没有生成或超时",
      "err_msg_cn": "安全码没有生成或超时",
      "err_msg_tc": "",
      "err_msg_en": "The security code was not generated or timed out"
      },
      {
      "code": 80310,
      "code_des": "filedog和云账号没有绑定关系",
      "err_msg_cn": "filedog和账号没有绑定关系",
      "err_msg_tc": "",
      "err_msg_en": "Filedog is not bound to accounts"
      },
      {
      "code": 80311,
      "code_des": "filedog已经废弃",
      "err_msg_cn": "filedog已经废弃",
      "err_msg_tc": "",
      "err_msg_en": "Filedog is obsolete"
      },
      {
      "code": 80400,
      "code_des": "当前雷克沙会员账号已绑定其他Apple账号",
      "err_msg_cn": "该雷克沙会员账号已绑定其他Apple账号",
      "err_msg_tc": "",
      "err_msg_en": "This Lexar account has been bound to another Apple account"
      },
      {
      "code": 80401,
      "code_des": "Apple账号已被绑定",
      "err_msg_cn": "Apple账号已被绑定",
      "err_msg_tc": "",
      "err_msg_en": "The Apple account has been bound"
      },
      {
      "code": 80501,
      "code_des": "不能添加自己为好友",
      "err_msg_cn": "不能添加自己为好友",
      "err_msg_tc": "",
      "err_msg_en": "You cannot add yourself as a friend"
      },
      {
      "code": 80502,
      "code_des": "好友数量超出限制",
      "err_msg_cn": "好友数量超出最大限制",
      "err_msg_tc": "",
      "err_msg_en": "The number of friends exceeded the maximum limit"
      },
      {
      "code": 80503,
      "code_des": "重复添加好友",
      "err_msg_cn": "重复添加好友",
      "err_msg_tc": "",
      "err_msg_en": "Repeat adding friends"
      },
      {
      "code": 80504,
      "code_des": "禁止访问",
      "err_msg_cn": "禁止访问",
      "err_msg_tc": "",
      "err_msg_en": "Access forbidden"
      },
      {
      "code": 80505,
      "code_des": "没有权限删除",
      "err_msg_cn": "没有权限删除",
      "err_msg_tc": "",
      "err_msg_en": "No permission to delete"
      },
      {
      "code": 80506,
      "code_des": "没有权限查看",
      "err_msg_cn": "没有权限查看",
      "err_msg_tc": "",
      "err_msg_en": "Have no permission to view"
      },
      {
      "code": 80507,
      "code_des": "分享超时",
      "err_msg_cn": "分享超时",
      "err_msg_tc": "",
      "err_msg_en": "Share timeout"
      },
      {
      "code": 80508,
      "code_des": "超出最大分享次数",
      "err_msg_cn": "超出最大分享次数",
      "err_msg_tc": "",
      "err_msg_en": "The number of shares exceeded the maximum"
      },
      {
      "code": 80601,
      "code_des": "未发现终端",
      "err_msg_cn": "未发现终端",
      "err_msg_tc": "",
      "err_msg_en": "No terminal found"
      },
      {
      "code": 80602,
      "code_des": "未发现公网ip",
      "err_msg_cn": "未发现公网ip",
      "err_msg_tc": "",
      "err_msg_en": "No public ip address found"
      },
      {
      "code": 80603,
      "code_des": "调用纯真ip服务异常",
      "err_msg_cn": "调用纯真ip服务异常",
      "err_msg_tc": "",
      "err_msg_en": "Invoking the pure ip service error"
      },
      {
      "code": 80604,
      "code_des": "扫码登陆状态码设置非法,当前0，设置为非1状态",
      "err_msg_cn": "扫码登录状态码设置非法,当前0，设置为非1状态",
      "err_msg_tc": "",
      "err_msg_en": "Scanning login status code is invalid.The current value is 0."
      },
      {
      "code": 80605,
      "code_des": "扫码登陆状态码设置非法,当前1，设置为非2且非3状态",
      "err_msg_cn": "扫码登录状态码设置非法,当前1，设置为非2且非3状态",
      "err_msg_tc": "",
      "err_msg_en": "Scanning login status code is invalid. The current value is 1"
      },
      {
      "code": 80606,
      "code_des": "扫码登陆状态码设置非法,当前2或3",
      "err_msg_cn": "扫码登录状态码设置非法,当前2或3",
      "err_msg_tc": "",
      "err_msg_en": "Scanning login status code is invalid. The current value is 2 or 3"
      },
      {
      "code": 80607,
      "code_des": "新终端密码登陆短信已验证",
      "err_msg_cn": "新终端密码登录短信已验证",
      "err_msg_tc": "",
      "err_msg_en": "The new terminal password has been authenticated"
      },
      {
      "code": 80608,
      "code_des": "新终端扫码登陆",
      "err_msg_cn": "新终端扫码登录",
      "err_msg_tc": "",
      "err_msg_en": "New termina log in by scanning QR code"
      },
      {
      "code": 80609,
      "code_des": "不能删除当前的登陆终端",
      "err_msg_cn": "不能删除当前的登录终端",
      "err_msg_tc": "",
      "err_msg_en": "Cannot delete the current login terminal"
      },
      {
      "code": 80701,
      "code_des": "打包下载文件大小超出限制",
      "err_msg_cn": "打包下载文件大小超出限制",
      "err_msg_tc": "",
      "err_msg_en": "The size of the package download file exceeds the limit"
      },
      {
      "code": 80702,
      "code_des": "打包下载文件数量超出限制",
      "err_msg_cn": "打包下载文件数量超出限制",
      "err_msg_tc": "",
      "err_msg_en": "The number of packages to download exceeds the limit"
      },
      {
      "code": 91001,
      "code_des": "固件升级失败",
      "err_msg_cn": "固件升级失败",
      "err_msg_tc": "",
      "err_msg_en": "Firmware upgrade failure"
      },
      {
      "code": 91002,
      "code_des": "固件正在升级",
      "err_msg_cn": "固件正在升级中",
      "err_msg_tc": "",
      "err_msg_en": "The firmware is being upgraded"
      },
      {
      "code": 91003,
      "code_des": "请求超时",
      "err_msg_cn": "请求超时",
      "err_msg_tc": "",
      "err_msg_en": "Request timeout"
      },
      {
      "code": 91004,
      "code_des": "任务不存在（已经完成，或无效任务ID）",
      "err_msg_cn": "任务不存在（已经完成，或无效任务ID）",
      "err_msg_tc": "",
      "err_msg_en": "Request timeout, task does not exist (completed, or invalid task ID)"
      },
      {
      "code": 91005,
      "code_des": "系统磁盘正在修复",
      "err_msg_cn": "系统磁盘正在修复",
      "err_msg_tc": "",
      "err_msg_en": "The system disk is being repaired"
      },
      {
      "code": 100002,
      "code_des": "文件/路径不存在",
      "err_msg_cn": "文件/路径不存在",
      "err_msg_tc": "",
      "err_msg_en": "The file/path does not exist"
      },
      {
      "code": 100005,
      "code_des": "磁盘IO错误，建议连接电脑修复磁盘",
      "err_msg_cn": "磁盘IO错误，建议连接电脑修复磁盘",
      "err_msg_tc": "",
      "err_msg_en": "Disk I/O error, please connect the computer to repair the disk"
      },
      {
      "code": 100007,
      "code_des": "参数列表过长",
      "err_msg_cn": "参数列表过长",
      "err_msg_tc": "",
      "err_msg_en": "The parameter list is too long"
      },
      {
      "code": 100012,
      "code_des": "内存不足",
      "err_msg_cn": "内存不足",
      "err_msg_tc": "",
      "err_msg_en": "Run out of memory"
      },
      {
      "code": 100017,
      "code_des": "文件已存在",
      "err_msg_cn": "文件已存在",
      "err_msg_tc": "",
      "err_msg_en": "File already exists"
      },
      {
      "code": 100020,
      "code_des": "路径不存在",
      "err_msg_cn": "路径不存在",
      "err_msg_tc": "",
      "err_msg_en": "Path does not exist"
      },
      {
      "code": 100022,
      "code_des": "无效参数",
      "err_msg_cn": "无效参数",
      "err_msg_tc": "",
      "err_msg_en": "Invalid arguments"
      },
      {
      "code": 100024,
      "code_des": "打开的文件过多",
      "err_msg_cn": "打开的文件过多",
      "err_msg_tc": "",
      "err_msg_en": "Too many files are open"
      },
      {
      "code": 100027,
      "code_des": "文件太大",
      "err_msg_cn": "文件太大",
      "err_msg_tc": "",
      "err_msg_en": "The file is too large."
      },
      {
      "code": 100028,
      "code_des": "No space left on device",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient disk space"
      },
      {
      "code": 100030,
      "code_des": "Read-only file system",
      "err_msg_cn": "文件系统只读了",
      "err_msg_tc": "",
      "err_msg_en": "File system read-only"
      },
      {
      "code": 100036,
      "code_des": "文件名太长",
      "err_msg_cn": "文件名太长",
      "err_msg_tc": "",
      "err_msg_en": "File name too long"
      },
      {
      "code": 101201,
      "code_des": "传参非法",
      "err_msg_cn": "传参非法",
      "err_msg_tc": "",
      "err_msg_en": "Illegal parameter passing"
      },
      {
      "code": 101202,
      "code_des": "目标记录已存在",
      "err_msg_cn": "文件已存在",
      "err_msg_tc": "",
      "err_msg_en": "File already exists"
      },
      {
      "code": 101203,
      "code_des": "目标记录不存在",
      "err_msg_cn": "文件不存在或已被删除",
      "err_msg_tc": "",
      "err_msg_en": "The file does not exist or has been deleted"
      },
      {
      "code": 101204,
      "code_des": "源记录不存在",
      "err_msg_cn": "文件不存在或已被删除",
      "err_msg_tc": "",
      "err_msg_en": "The file does not exist or has been deleted"
      },
      {
      "code": 101205,
      "code_des": "目的文件是目录",
      "err_msg_cn": "目的文件是目录",
      "err_msg_tc": "",
      "err_msg_en": "The destination file is the directory"
      },
      {
      "code": 101206,
      "code_des": "目的文件不是目录",
      "err_msg_cn": "目的文件不是目录",
      "err_msg_tc": "",
      "err_msg_en": "The destination file is not a directory"
      },
      {
      "code": 101211,
      "code_des": "标签名不存在",
      "err_msg_cn": "标签名不存在",
      "err_msg_tc": "",
      "err_msg_en": "The label name does not exist"
      },
      {
      "code": 101301,
      "code_des": "当前系统盘需要修复",
      "err_msg_cn": "当前系统盘需要修复",
      "err_msg_tc": "",
      "err_msg_en": "The current system disk needs to be repaired"
      },
      {
      "code": 101400,
      "code_des": "Father path can't copy or move to child path",
      "err_msg_cn": "不允许将父路径复制或移动到其子路径",
      "err_msg_tc": "",
      "err_msg_en": "Copying or moving a parent path to a child path is not allowed"
      },
      {
      "code": 101401,
      "code_des": "Invalid file path or file name (fat32 filesystem does not support ? in filename)",
      "err_msg_cn": "无效的路径或文件名",
      "err_msg_tc": "",
      "err_msg_en": "Invalid path or file name"
      },
      {
      "code": 101800,
      "code_des": "超过一次允许操作的最大回收站文件数",
      "err_msg_cn": "超出单次操作回收站最大文件数",
      "err_msg_tc": "",
      "err_msg_en": "The number of files in the recycle bin exceeds the maximum number of files in a single operation"
      },
      {
      "code": 200001,
      "code_des": "超出一次操作限制文件的个数",
      "err_msg_cn": "单次操作最大不超过1000个文件",
      "err_msg_tc": "",
      "err_msg_en": "A single operation contains a maximum of 1000 files"
      },
      {
      "code": 220001,
      "code_des": "标签名长度错误",
      "err_msg_cn": "标签名长度错误",
      "err_msg_tc": "",
      "err_msg_en": "The length of the label name is incorrect"
      },
      {
      "code": 230001,
      "code_des": "EFS TOKEN EXPIRED",
      "err_msg_cn": "加密空间登录超时，请重新登录",
      "err_msg_tc": "",
      "err_msg_en": "Encrypted space login times out, please log in again"
      },
      {
      "code": 230002,
      "code_des": "EFS PARMETER ERROR",
      "err_msg_cn": "参数错误",
      "err_msg_tc": "",
      "err_msg_en": "Parameter error"
      },
      {
      "code": 230003,
      "code_des": "WRONG PASSWORD",
      "err_msg_cn": "密码不匹配",
      "err_msg_tc": "",
      "err_msg_en": "Password mismatch"
      },
      {
      "code": 230004,
      "code_des": "EFS ALREADY OPENED",
      "err_msg_cn": "加密空间已开启，请直接登录",
      "err_msg_tc": "",
      "err_msg_en": "The encryption space is enabled. Please log in directly"
      },
      {
      "code": 230005,
      "code_des": "EFS KEY SAVE FAILED",
      "err_msg_cn": "加密空间加密参数保存失败",
      "err_msg_tc": "",
      "err_msg_en": "Encryption space encryption parameters fail to be saved"
      },
      {
      "code": 230006,
      "code_des": "EFS NOT INIT",
      "err_msg_cn": "加密空间未初始化",
      "err_msg_tc": "",
      "err_msg_en": "The encrypted space is not initialized"
      },
      {
      "code": 230007,
      "code_des": "EFS ERR GET FILES NUM",
      "err_msg_cn": "获取加密空间文件数失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to obtain the number of encrypted space files."
      },
      {
      "code": 230008,
      "code_des": "EFS FILE OUT OF RANGE",
      "err_msg_cn": "加密空间文件请求失败",
      "err_msg_tc": "",
      "err_msg_en": "The encrypted space file request failed."
      },
      {
      "code": 230009,
      "code_des": "EFS failed to reset password",
      "err_msg_cn": "加密空间密码重置失败，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Failed to reset the password of the encrypted space. Please try again"
      },
      {
      "code": 230010,
      "code_des": "EFS failed to update bind info",
      "err_msg_cn": "加密空间上传用户绑定信息失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to upload user binding information of the encrypted space"
      },
      {
      "code": 230011,
      "code_des": "EFS SPACE MOUNT FAILED(E_EFS_LOGIN_REPEATED)",
      "err_msg_cn": "加密空间挂载失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to mount the encrypted space"
      },
      {
      "code": 260000,
      "code_des": "活动相册不允许再次添加文件",
      "err_msg_cn": "共享相册不允许再次添加文件",
      "err_msg_tc": "",
      "err_msg_en": "The shared album does not allow to add files again"
      },
      {
      "code": 260001,
      "code_des": "创建的活动相册数超过最大允许数",
      "err_msg_cn": "共享相册数已超过最大限制",
      "err_msg_tc": "",
      "err_msg_en": "The number of shared albums exceeded the upper limit."
      },
      {
      "code": 260002,
      "code_des": "创建活动相册失败",
      "err_msg_cn": "创建共享相册失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to create a shared album"
      },
      {
      "code": 260003,
      "code_des": "访问的活动相册不存在",
      "err_msg_cn": "访问的共享相册不存在",
      "err_msg_tc": "",
      "err_msg_en": "The accessed shared album does not exist"
      },
      {
      "code": 260004,
      "code_des": "相册已存在",
      "err_msg_cn": "相册已存在",
      "err_msg_tc": "",
      "err_msg_en": "Album already exists"
      },
      {
      "code": 260005,
      "code_des": "相册名称已存在",
      "err_msg_cn": "相册名称已存在",
      "err_msg_tc": "",
      "err_msg_en": "The album name already exists"
      },
      {
      "code": 260006,
      "code_des": "共享相册用户不存在",
      "err_msg_cn": "共享相册用户不存在",
      "err_msg_tc": "",
      "err_msg_en": "The shared album user does not exist"
      },
      {
      "code": 260007,
      "code_des": "共享相册只支持添加照片和视频",
      "err_msg_cn": "共享相册只支持添加照片和视频",
      "err_msg_tc": "",
      "err_msg_en": "Only photos and videos can be added to shared albums"
      },
      {
      "code": 260102,
      "code_des": "需要验证码校验",
      "err_msg_cn": "需要验证码校验",
      "err_msg_tc": "",
      "err_msg_en": "The verification code is required"
      },
      {
      "code": 260103,
      "code_des": "验证码校验失败",
      "err_msg_cn": "验证码校验失败",
      "err_msg_tc": "",
      "err_msg_en": "The verification code fails."
      },
      {
      "code": 260104,
      "code_des": "发送验证码失败",
      "err_msg_cn": "发送验证码失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to send the verification code. "
      },
      {
      "code": 260105,
      "code_des": "验证码频繁发送",
      "err_msg_cn": "验证码频繁发送",
      "err_msg_tc": "",
      "err_msg_en": "The verification code is frequently sent"
      },
      {
      "code": 260106,
      "code_des": "发送邀请信息失败",
      "err_msg_cn": "发送邀请信息失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to send the invitation information."
      },
      {
      "code": 260108,
      "code_des": "解绑云账号失败",
      "err_msg_cn": "账号解绑失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to unbind the account"
      },
      {
      "code": 260110,
      "code_des": "输入的账号未绑定过该设备",
      "err_msg_cn": "输入的账号未绑定过该设备",
      "err_msg_tc": "",
      "err_msg_en": "The account has not been bound to the device"
      },
      {
      "code": 260111,
      "code_des": "绑定码不匹配",
      "err_msg_cn": "绑定码不匹配",
      "err_msg_tc": "",
      "err_msg_en": "The binding code does not match"
      },
      {
      "code": 260112,
      "code_des": "绑定码已过期",
      "err_msg_cn": "绑定码已过期",
      "err_msg_tc": "",
      "err_msg_en": "The binding code has expired"
      },
      {
      "code": 260113,
      "code_des": "绑定码不存在",
      "err_msg_cn": "绑定码不存在",
      "err_msg_tc": "",
      "err_msg_en": "The binding code does not exist"
      },
      {
      "code": 260301,
      "code_des": "插件平台的配置文件不存在",
      "err_msg_cn": "插件平台的配置文件不存在",
      "err_msg_tc": "",
      "err_msg_en": "The configuration file for the plug-in platform does not exist"
      },
      {
      "code": 260302,
      "code_des": "插件平台的配置文件损毁",
      "err_msg_cn": "插件平台的配置文件损毁",
      "err_msg_tc": "",
      "err_msg_en": "The configuration file of the plug-in platform is damaged"
      },
      {
      "code": 260303,
      "code_des": "插件平台不能获取设备信息",
      "err_msg_cn": "插件平台不能获取设备信息",
      "err_msg_tc": "",
      "err_msg_en": "The plugin platform cannot get device information"
      },
      {
      "code": 260304,
      "code_des": "插件平台通过curl访问服务器失败",
      "err_msg_cn": "插件平台通过curl访问服务器失败",
      "err_msg_tc": "",
      "err_msg_en": "The plugin platform failed to access the server through curl\n\n"
      },
      {
      "code": 260305,
      "code_des": "插件平台下载的插件的MD5错误",
      "err_msg_cn": "插件平台下载的插件的MD5错误",
      "err_msg_tc": "",
      "err_msg_en": "MD5 error of the plugin downloaded"
      },
      {
      "code": 260306,
      "code_des": "插件平台解压缩下载的插件失败",
      "err_msg_cn": "插件平台解压缩下载的插件失败",
      "err_msg_tc": "",
      "err_msg_en": "Decompress the downloaded plugin failed"
      },
      {
      "code": 260307,
      "code_des": "插件平台的插件ID错误",
      "err_msg_cn": "插件平台的插件ID错误",
      "err_msg_tc": "",
      "err_msg_en": "Plugin ID wrong"
      },
      {
      "code": 260308,
      "code_des": "插件平台初始化失败",
      "err_msg_cn": "插件平台初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Plugin platform initialize failed"
      },
      {
      "code": 260309,
      "code_des": "服务器的插件配置文件损坏",
      "err_msg_cn": "服务器的插件配置文件损坏",
      "err_msg_tc": "",
      "err_msg_en": "The plugin configuration file of the server is damaged"
      },
      {
      "code": 260310,
      "code_des": "当前固件不支持该插件，需要升级固件",
      "err_msg_cn": "当前固件不支持该插件，需要升级固件",
      "err_msg_tc": "",
      "err_msg_en": "The current firmware does not support the plugin. You need to upgrade the firmware"
      },
      {
      "code": 260312,
      "code_des": "插件（安装、卸载、更新）时运行错误，请重新（安装、卸载、更新）",
      "err_msg_cn": "插件（安装、卸载、更新）时运行错误，请重新（安装、卸载、更新）",
      "err_msg_tc": "",
      "err_msg_en": "Plugin (install, uninstall, update) running error, please re-(install, uninstall, update)"
      },
      {
      "code": 260313,
      "code_des": "插件（安装、卸载、更新）失败",
      "err_msg_cn": "插件（安装、卸载、更新）失败",
      "err_msg_tc": "",
      "err_msg_en": "Plugin (install, uninstall, update) failed"
      },
      {
      "code": 260314,
      "code_des": "插件进度查询失败，插件可能（更新、安装）失败，或未（更新、安装）中",
      "err_msg_cn": "插件进度查询失败，插件可能（更新、安装）失败，或未（更新、安装）中",
      "err_msg_tc": "",
      "err_msg_en": "Plugin progress query failed, plugin may (update, install) failed, or not (update, install)"
      },
      {
      "code": 260401,
      "code_des": "指定的home_name不存在",
      "err_msg_cn": "指定的home_name不存在",
      "err_msg_tc": "",
      "err_msg_en": "The specified home_name does not exist"
      },
      {
      "code": 260402,
      "code_des": "指定的home_name已被绑定",
      "err_msg_cn": "指定的home_name已被绑定",
      "err_msg_tc": "",
      "err_msg_en": "The specified home_name has been bound"
      },
      {
      "code": 260403,
      "code_des": "指定的cloud_user_id已被绑定",
      "err_msg_cn": "指定的cloud_user_id已被绑定",
      "err_msg_tc": "",
      "err_msg_en": "The specified cloud_user_id has been bound"
      },
      {
      "code": 260501,
      "code_des": "路径中的磁盘id不存在",
      "err_msg_cn": "路径中的磁盘id不存在",
      "err_msg_tc": "",
      "err_msg_en": "The disk_id in the path does not exist"
      },
      {
      "code": 260502,
      "code_des": "路径中的挂载路径不存在",
      "err_msg_cn": "路径中的挂载路径不存在",
      "err_msg_tc": "",
      "err_msg_en": "The mount path does not exist"
      },
      {
      "code": 260600,
      "code_des": "P2P模块没有初始化",
      "err_msg_cn": "P2P模块没有初始化",
      "err_msg_tc": "",
      "err_msg_en": "The P2P module is not initialized"
      },
      {
      "code": 260601,
      "code_des": "端口映射数量达到最大值了（默认最大256个）",
      "err_msg_cn": "端口映射数量达到最大值了（默认最大256个）",
      "err_msg_tc": "",
      "err_msg_en": "The number of port mappings reached the maximum value (256 by default)."
      },
      {
      "code": 260602,
      "code_des": "端口绑定失败，因为本地端口被占用",
      "err_msg_cn": "端口绑定失败，因为本地端口被占用",
      "err_msg_tc": "",
      "err_msg_en": "Port binding failed because the local port was occupied."
      },
      {
      "code": 260603,
      "code_des": "端口监听失败，因为端口被占用",
      "err_msg_cn": "端口监听失败，因为端口被占用",
      "err_msg_tc": "",
      "err_msg_en": "Port listening failed because the port was occupied."
      },
      {
      "code": 260604,
      "code_des": "P2P模块创建线程失败",
      "err_msg_cn": "P2P模块创建线程失败",
      "err_msg_tc": "",
      "err_msg_en": "The P2P module failed to create a thread"
      },
      {
      "code": 260605,
      "code_des": "agent已经连接到一个server",
      "err_msg_cn": "agent已经连接到一个server",
      "err_msg_tc": "",
      "err_msg_en": "The agent is connected to a server"
      },
      {
      "code": 260606,
      "code_des": "agent和server之间的连接断开了",
      "err_msg_cn": "agent和server之间的连接断开了",
      "err_msg_tc": "",
      "err_msg_en": "The connection between the agent and server is disconnected"
      },
      {
      "code": 260607,
      "code_des": "P2P模块已经初始化过了",
      "err_msg_cn": "P2P模块已经初始化过了",
      "err_msg_tc": "",
      "err_msg_en": "The P2P module has been initialized"
      },
      {
      "code": 260608,
      "code_des": "连接到server失败，因为认证错误",
      "err_msg_cn": "连接到server失败，因为认证错误",
      "err_msg_tc": "",
      "err_msg_en": "Failed to connect to the server because of an authentication error"
      },
      {
      "code": 260609,
      "code_des": "认证数据长度过长",
      "err_msg_cn": "认证数据长度过长",
      "err_msg_tc": "",
      "err_msg_en": "The authentication data length is too long."
      },
      {
      "code": 260610,
      "code_des": "session id非法",
      "err_msg_cn": "session id非法",
      "err_msg_tc": "",
      "err_msg_en": "Session id invalid"
      },
      {
      "code": 260611,
      "code_des": "uuid非法",
      "err_msg_cn": "uuid非法",
      "err_msg_tc": "uuid非法",
      "err_msg_en": "Invalid uuid"
      },
      {
      "code": 260612,
      "code_des": "指定的设备不支持高级功能",
      "err_msg_cn": "指定的设备不支持高级功能",
      "err_msg_tc": "指定的設備不支持高級功能",
      "err_msg_en": "The specified device does not support advanced functions"
      },
      {
      "code": 260613,
      "code_des": "此uid无法通过中转服务器建立连接",
      "err_msg_cn": "此uid无法通过中转服务器建立连接",
      "err_msg_tc": "此uid無法通過中轉服務器建立連接",
      "err_msg_en": "The uid could not establish a connection through the transit server"
      },
      {
      "code": 260614,
      "code_des": "server没有登录到IOTC服务器",
      "err_msg_cn": "server没有登录到IOTC服务器",
      "err_msg_tc": "server沒有登錄到IOTC服務器",
      "err_msg_en": "Server is not logged in to the IOTC server"
      },
      {
      "code": 260615,
      "code_des": "server端没有监听连接",
      "err_msg_cn": "server端没有监听连接",
      "err_msg_tc": "server端沒有監聽連接",
      "err_msg_en": "The server is not listening for the connection"
      },
      {
      "code": 260616,
      "code_des": "无法访问互联网",
      "err_msg_cn": "无法访问互联网",
      "err_msg_tc": "無法訪問互聯網",
      "err_msg_en": "Unable to access the Internet"
      },
      {
      "code": 260617,
      "code_des": "agent连接到server失败，可能是因为网络不稳定",
      "err_msg_cn": "agent连接到server失败，可能是因为网络不稳定",
      "err_msg_tc": "agent連接到server失敗，可能是因為網絡不穩定",
      "err_msg_en": "The agent fails to connect to the server because the network is unstable"
      },
      {
      "code": 260618,
      "code_des": "server连接到IOTC服务器失败，但仍然能被agent通过局域网连接",
      "err_msg_cn": "server连接到IOTC服务器失败，但仍然能被agent通过局域网连接",
      "err_msg_tc": "server連接到IOTC服務器失敗，但仍然能被agent通過局域網連接",
      "err_msg_en": "The server fails to connect to the IOTC server, but can still be connected by the agent through the LAN"
      },
      {
      "code": 260619,
      "code_des": "server的连接达到最大值",
      "err_msg_cn": "server的连接达到最大值",
      "err_msg_tc": "server的連接達到最大值",
      "err_msg_en": "The number of connections to the server reached the maximum."
      },
      {
      "code": 260620,
      "code_des": "agent获取session信息失败",
      "err_msg_cn": "agent获取session信息失败",
      "err_msg_tc": "agent獲取session信息失敗",
      "err_msg_en": "The agent fails to obtain session information."
      },
      {
      "code": 260621,
      "code_des": "转给函数的参数错误",
      "err_msg_cn": "转给函数的参数错误",
      "err_msg_tc": "轉給函數的參數錯誤",
      "err_msg_en": "Incorrect argument to the function"
      },
      {
      "code": 260622,
      "code_des": "操作系统没有足够的内存去使用malloc",
      "err_msg_cn": "操作系统没有足够的内存去使用malloc",
      "err_msg_tc": "操作系統沒有足夠的內存去使用malloc",
      "err_msg_en": "The operating system does not have enough memory to use malloc"
      },
      {
      "code": 260623,
      "code_des": "agent没有连接",
      "err_msg_cn": "agent没有连接",
      "err_msg_tc": "agent沒有連接",
      "err_msg_en": "Agent is not connected"
      },
      {
      "code": 260624,
      "code_des": "获取session失败",
      "err_msg_cn": "获取session失败",
      "err_msg_tc": "獲取session失敗",
      "err_msg_en": "Failed to obtain session"
      },
      {
      "code": 260625,
      "code_des": "连接取消了",
      "err_msg_cn": "连接取消了",
      "err_msg_tc": "連接取消了",
      "err_msg_en": "Connection cancelled"
      },
      {
      "code": 260626,
      "code_des": "session没有对端端口",
      "err_msg_cn": "session没有对端端口",
      "err_msg_tc": "",
      "err_msg_en": "Session does not have a peer port."
      },
      {
      "code": 260627,
      "code_des": "session连接失败，正在重连",
      "err_msg_cn": "session连接失败，正在重连",
      "err_msg_tc": "",
      "err_msg_en": "Session connection failed, reconnecting"
      },
      {
      "code": 260701,
      "code_des": "IOTC服务器没有回复，可能是由多种联网问题引起的",
      "err_msg_cn": "IOTC服务器没有回复，可能是由多种联网问题引起的",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC server did not respond, possibly due to a variety of networking issues"
      },
      {
      "code": 260702,
      "code_des": "IOTC主机不能解析其域名，可能是联网问题或DNS设置问题引起的",
      "err_msg_cn": "IOTC主机不能解析其域名，可能是联网问题或DNS设置问题引起的",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC host cannot resolve its domain name, possibly due to a networking problem or a DNS setup problem"
      },
      {
      "code": 260703,
      "code_des": "IOTC模块已经初始化",
      "err_msg_cn": "IOTC模块已经初始化",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module has been initialized"
      },
      {
      "code": 260704,
      "code_des": "IOTC模块不能初始化互斥锁",
      "err_msg_cn": "IOTC模块不能初始化互斥锁",
      "err_msg_tc": "",
      "err_msg_en": "IOTC modules cannot initialize mutex"
      },
      {
      "code": 260705,
      "code_des": "IOTC模块不能创建线程",
      "err_msg_cn": "IOTC模块不能创建线程",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module cannot create threads"
      },
      {
      "code": 260706,
      "code_des": "IOTC模块不能创建socket",
      "err_msg_cn": "IOTC模块不能创建socket",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module cannot create a socket"
      },
      {
      "code": 260707,
      "code_des": "IOTC模块不能设置socket选项",
      "err_msg_cn": "IOTC模块不能设置socket选项",
      "err_msg_tc": "",
      "err_msg_en": "Socket options cannot be set for the IOTC module"
      },
      {
      "code": 260708,
      "code_des": "IOTC模块不能绑定套接字",
      "err_msg_cn": "IOTC模块不能绑定套接字",
      "err_msg_tc": "",
      "err_msg_en": "IOTC modules cannot bind sockets"
      },
      {
      "code": 260710,
      "code_des": "指定的UID未获得许可或过期",
      "err_msg_cn": "指定的UID未获得许可或过期",
      "err_msg_tc": "",
      "err_msg_en": "The specified UID is not licensed or expired"
      },
      {
      "code": 260711,
      "code_des": "该设备目前已经在登录过程中",
      "err_msg_cn": "该设备目前已经在登录过程中",
      "err_msg_tc": "",
      "err_msg_en": "The device is being logged in"
      },
      {
      "code": 260712,
      "code_des": "IOTC模块尚未初始化",
      "err_msg_cn": "IOTC模块尚未初始化",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module has not been initialized"
      },
      {
      "code": 260713,
      "code_des": "执行超时",
      "err_msg_cn": "执行超时",
      "err_msg_tc": "",
      "err_msg_en": "Execution timeout"
      },
      {
      "code": 260714,
      "code_des": "指定的IOTC会话ID不合法",
      "err_msg_cn": "指定的IOTC会话ID不合法",
      "err_msg_tc": "",
      "err_msg_en": "The specified IOTC session ID is invalid"
      },
      {
      "code": 260715,
      "code_des": "IOTC服务器不知道指定的设备名称",
      "err_msg_cn": "IOTC服务器不知道指定的设备名称",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC server does not know the specified device name"
      },
      {
      "code": 260716,
      "code_des": "IOTC模块获取本地IP地址失败",
      "err_msg_cn": "IOTC模块获取本地IP地址失败",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module failed to obtain the local IP address"
      },
      {
      "code": 260717,
      "code_des": "设备已经开始监听来自客户端的连接",
      "err_msg_cn": "设备已经开始监听来自客户端的连接",
      "err_msg_tc": "",
      "err_msg_en": "The device has started listening for connections from the client"
      },
      {
      "code": 260718,
      "code_des": "IOTC的会议次数已达到最大值",
      "err_msg_cn": "IOTC的会议次数已达到最大值",
      "err_msg_tc": "",
      "err_msg_en": "The number of IOTC meetings has reached its maximum"
      },
      {
      "code": 260719,
      "code_des": "IOTC服务器无法定位指定的设备",
      "err_msg_cn": "IOTC服务器无法定位指定的设备",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC server cannot locate the specified device\n\n"
      },
      {
      "code": 260722,
      "code_des": "远程站点已经关闭此ioct会话",
      "err_msg_cn": "远程站点已经关闭此ioct会话",
      "err_msg_tc": "",
      "err_msg_en": "The remote site has closed this ioct session\n\n"
      },
      {
      "code": 260723,
      "code_des": "由于对端没有在指定时间内回复，所以会话断开",
      "err_msg_cn": "由于对端没有在指定时间内回复，所以会话断开",
      "err_msg_tc": "",
      "err_msg_en": "The peer end did not reply within the specified time, so the session was disconnected"
      },
      {
      "code": 260724,
      "code_des": "客户端连接设备失败，因为设备没有监听连接",
      "err_msg_cn": "客户端连接设备失败，因为设备没有监听连接",
      "err_msg_tc": "",
      "err_msg_en": "The client failed to connect to the device because the device was not listening for the connection\n\n"
      },
      {
      "code": 260726,
      "code_des": "数据传输时，未打开指定channel id的IOTC通道",
      "err_msg_cn": "数据传输时，未打开指定channel id的IOTC通道",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC channel with the specified channel id was not opened during data transmission"
      },
      {
      "code": 260727,
      "code_des": "客户通过IOTC_Connect_Stop函数端口和设备的连接",
      "err_msg_cn": "客户通过IOTC_Connect_Stop函数端口和设备的连接",
      "err_msg_tc": "",
      "err_msg_en": "Customers Connect to devices through IOTC Connect Stop function ports"
      },
      {
      "code": 260728,
      "code_des": "初始化IOTC模块时指定的master太少",
      "err_msg_cn": "初始化IOTC模块时指定的master太少",
      "err_msg_tc": "",
      "err_msg_en": "Too few masters were specified when initializing the IOTC module\n\n"
      },
      {
      "code": 260729,
      "code_des": "客户端密钥错误，无法通过设备认证",
      "err_msg_cn": "客户端密钥错误，无法通过设备认证",
      "err_msg_tc": "",
      "err_msg_en": "The client key is incorrect and fails to pass the device authentication"
      },
      {
      "code": 260731,
      "code_des": "一个IOTC会话的IOTC通道数量已达到最大值",
      "err_msg_cn": "一个IOTC会话的IOTC通道数量已达到最大值",
      "err_msg_tc": "",
      "err_msg_en": "The number of IOTC channels in an IOTC session has reached its maximum"
      },
      {
      "code": 260732,
      "code_des": "不能通过IP或主机名方式连接到主机，包括UDP和TCP模式",
      "err_msg_cn": "不能通过IP或主机名方式连接到主机，包括UDP和TCP模式",
      "err_msg_tc": "",
      "err_msg_en": "Cannot connect to a host by IP or host name, including UDP and TCP"
      },
      {
      "code": 260733,
      "code_des": "无法通过TCP连接到IOTC服务器",
      "err_msg_cn": "无法通过TCP连接到IOTC服务器",
      "err_msg_tc": "",
      "err_msg_en": "Unable to connect to the IOTC server over TCP"
      },
      {
      "code": 260734,
      "code_des": "客户想通过非安全模式连接到只支持安全模式的设备",
      "err_msg_cn": "客户想通过非安全模式连接到只支持安全模式的设备",
      "err_msg_tc": "",
      "err_msg_en": "The customer wants to connect to a secure mode only device through insecure mode"
      },
      {
      "code": 260735,
      "code_des": "客户想通过安全模式连接到不支持安全模式的设备",
      "err_msg_cn": "客户想通过安全模式连接到不支持安全模式的设备",
      "err_msg_tc": "",
      "err_msg_en": "The customer wants to connect to a device that does not support secure mode through secure mode"
      },
      {
      "code": 260736,
      "code_des": "设备不支持安全模式连接",
      "err_msg_cn": "设备不支持安全模式连接",
      "err_msg_tc": "",
      "err_msg_en": "The device does not support connection in secure mode"
      },
      {
      "code": 260737,
      "code_des": "设备不支持非安全模式下的连接",
      "err_msg_cn": "设备不支持非安全模式下的连接",
      "err_msg_tc": "",
      "err_msg_en": "The device does not support connections in insecure mode"
      },
      {
      "code": 260739,
      "code_des": "设备停止监听来自客户端的连接",
      "err_msg_cn": "设备停止监听来自客户端的连接",
      "err_msg_tc": "",
      "err_msg_en": "The device stops listening for connections from the client"
      },
      {
      "code": 260740,
      "code_des": "指定的设备不支持高级功能（TCP中继和P2PTunnel模块）",
      "err_msg_cn": "指定的设备不支持高级功能（TCP中继和P2PTunnel模块）",
      "err_msg_tc": "",
      "err_msg_en": "The specified device does not support advanced functions (TCP trunk and P2PTunnel module)."
      },
      {
      "code": 260741,
      "code_des": "网络不可达，请检查网络设置",
      "err_msg_cn": "网络不可达，请检查网络设置",
      "err_msg_tc": "",
      "err_msg_en": "The network is unreachable. Please check the network Settings"
      },
      {
      "code": 260742,
      "code_des": "客户端通过中继方式连接设备失败",
      "err_msg_cn": "客户端通过中继方式连接设备失败",
      "err_msg_tc": "",
      "err_msg_en": "The client fails to connect to the device through the trunk"
      },
      {
      "code": 260743,
      "code_des": "客户端使用UDP中继方式连接设备失败，因为IOTC服务器不支持UDP中继模式",
      "err_msg_cn": "客户端使用UDP中继方式连接设备失败，因为IOTC服务器不支持UDP中继模式",
      "err_msg_tc": "",
      "err_msg_en": "The client failed to connect to the device in UDP relay mode because the IOTC server does not support the UDP relay mode"
      },
      {
      "code": 260744,
      "code_des": "当设备登录或客户端连接时，没有IOTC服务器信息，因为没有IOTC服务器运行或没有添加IOTC服务器列表",
      "err_msg_cn": "当设备登录或客户端连接时，没有IOTC服务器信息，因为没有IOTC服务器运行或没有添加IOTC服务器列表",
      "err_msg_tc": "",
      "err_msg_en": "When the device is logged in or the client is connected, there is no IOTC server information because no IOTC server is running or no IOTC server list is added"
      },
      {
      "code": 260745,
      "code_des": "连接设备有重复的登录，可能无法连接",
      "err_msg_cn": "连接设备有重复的登录，可能无法连接",
      "err_msg_tc": "",
      "err_msg_en": "The connected device has repeated logins and may not be able to connect"
      },
      {
      "code": 260746,
      "code_des": "传递给函数的参数无效",
      "err_msg_cn": "传递给函数的参数无效",
      "err_msg_tc": "",
      "err_msg_en": "Invalid argument passed to function"
      },
      {
      "code": 260747,
      "code_des": "远端设备不支持部分编码",
      "err_msg_cn": "远端设备不支持部分编码",
      "err_msg_tc": "",
      "err_msg_en": "The remote device does not support partial encoding"
      },
      {
      "code": 260748,
      "code_des": "无法连接远端设备的空闲会话",
      "err_msg_cn": "无法连接远端设备的空闲会话",
      "err_msg_tc": "",
      "err_msg_en": "The idle session on the remote device cannot be connected"
      },
      {
      "code": 260749,
      "code_des": "该函数调用是一个阻塞调用并且被其他线程调用",
      "err_msg_cn": "该函数调用是一个阻塞调用并且被其他线程调用",
      "err_msg_tc": "",
      "err_msg_en": "The function call is a blocking call and is called by another thread"
      },
      {
      "code": 260750,
      "code_des": "会话已经结束了",
      "err_msg_cn": "会话已经结束了",
      "err_msg_tc": "",
      "err_msg_en": "The conversation has ended"
      },
      {
      "code": 260751,
      "code_des": "远端不支持此功能",
      "err_msg_cn": "远端不支持此功能",
      "err_msg_tc": "",
      "err_msg_en": "The remote end does not support this function"
      },
      {
      "code": 260752,
      "code_des": "该函数被相关函数终止",
      "err_msg_cn": "该函数被相关函数终止",
      "err_msg_tc": "",
      "err_msg_en": "The function is terminated by the correlation function"
      },
      {
      "code": 260753,
      "code_des": "缓冲区大小超过最大包大小",
      "err_msg_cn": "缓冲区大小超过最大包大小",
      "err_msg_tc": "",
      "err_msg_en": "The buffer size exceeds the maximum packet size"
      },
      {
      "code": 260754,
      "code_des": "服务器不支持此特性",
      "err_msg_cn": "服务器不支持此特性",
      "err_msg_tc": "",
      "err_msg_en": "Server does not support this feature"
      },
      {
      "code": 260755,
      "code_des": "找不到写入数据的路径",
      "err_msg_cn": "找不到写入数据的路径",
      "err_msg_tc": "",
      "err_msg_en": "The path to write data cannot be found"
      },
      {
      "code": 260756,
      "code_des": "Start函数没有被调用",
      "err_msg_cn": "Start函数没有被调用",
      "err_msg_tc": "",
      "err_msg_en": "The Start function is not called"
      },
      {
      "code": 260757,
      "code_des": "已经在处理",
      "err_msg_cn": "已经在处理",
      "err_msg_tc": "",
      "err_msg_en": "Processing now"
      },
      {
      "code": 260758,
      "code_des": "没有足够的内存",
      "err_msg_cn": "没有足够的内存",
      "err_msg_tc": "",
      "err_msg_en": "Not enough memory"
      },
      {
      "code": 260759,
      "code_des": "该设备被禁止和锁定，此错误代码不再被使用",
      "err_msg_cn": "该设备被禁止和锁定，此错误代码不再被使用",
      "err_msg_tc": "",
      "err_msg_en": "The device is disabled and locked, and this error code is no longer used"
      },
      {
      "code": 260760,
      "code_des": "IOTC主服务器没有响应，可能是因为各种网络问题导致的",
      "err_msg_cn": "IOTC主服务器没有响应，可能是因为各种网络问题导致的",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC main server is not responding, possibly due to various network issues"
      },
      {
      "code": 260761,
      "code_des": "IOTC模块存在一些资源分配问题",
      "err_msg_cn": "IOTC模块存在一些资源分配问题",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC module has some resource allocation issues"
      },
      {
      "code": 260762,
      "code_des": "IOTC写可靠发送队列已满",
      "err_msg_cn": "IOTC写可靠发送队列已满",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC Write reliable send queue is full"
      },
      {
      "code": 260763,
      "code_des": "不支持该特性",
      "err_msg_cn": "不支持该特性",
      "err_msg_tc": "",
      "err_msg_en": "This feature is not supported"
      },
      {
      "code": 260764,
      "code_des": "设备处于睡眠模式",
      "err_msg_cn": "设备处于睡眠模式",
      "err_msg_tc": "",
      "err_msg_en": "The device is in sleep mode"
      },
      {
      "code": 260765,
      "code_des": "设备在TCP模式下不支持此功能",
      "err_msg_cn": "设备在TCP模式下不支持此功能",
      "err_msg_tc": "",
      "err_msg_en": "The device does not support this function in TCP mode"
      },
      {
      "code": 260766,
      "code_des": "没有调用IOTC_WakeUp_Init",
      "err_msg_cn": "没有调用IOTC_WakeUp_Init",
      "err_msg_tc": "",
      "err_msg_en": "IOTC_WakeUp_Init is not called"
      },
      {
      "code": 260767,
      "code_des": "由于错误的IOTCPort而被设备拒绝",
      "err_msg_cn": "由于错误的IOTCPort而被设备拒绝",
      "err_msg_tc": "",
      "err_msg_en": "Device rejected because of incorrect IOTCPort"
      },
      {
      "code": 260768,
      "code_des": "由于错误的验证密钥而被设备拒绝",
      "err_msg_cn": "由于错误的验证密钥而被设备拒绝",
      "err_msg_tc": "",
      "err_msg_en": "Device rejected due to incorrect authentication key"
      },
      {
      "code": 260769,
      "code_des": "由于禁用认证而被设备拒绝",
      "err_msg_cn": "由于禁用认证而被设备拒绝",
      "err_msg_tc": "",
      "err_msg_en": "Rejected by the device because authentication is disabled"
      },
      {
      "code": 260770,
      "code_des": "有些函数只能在设备登录成功后才能调用",
      "err_msg_cn": "有些函数只能在设备登录成功后才能调用",
      "err_msg_tc": "",
      "err_msg_en": "Some functions can only be called after the device has successfully logged in"
      },
      {
      "code": 260771,
      "code_des": "需要用IOTC_Device_loginEx登录，而不是IOTC_Device_login",
      "err_msg_cn": "需要用IOTC_Device_loginEx登录，而不是IOTC_Device_login",
      "err_msg_tc": "",
      "err_msg_en": "You need to login with IOTC_Device_loginEx, not IOTC_Device_login"
      },
      {
      "code": 260772,
      "code_des": "函数调用被拒绝，因为至少有一个IOTC会话正在使用",
      "err_msg_cn": "函数调用被拒绝，因为至少有一个IOTC会话正在使用",
      "err_msg_tc": "",
      "err_msg_en": "Function call rejected because at least one IOTC session is in use"
      },
      {
      "code": 260790,
      "code_des": "所有服务器响应都找不到设备",
      "err_msg_cn": "所有服务器响应都找不到设备",
      "err_msg_tc": "",
      "err_msg_en": "None of the server responses found the device"
      },
      {
      "code": 260791,
      "code_des": "IOTC主服务器无效",
      "err_msg_cn": "IOTC主服务器无效",
      "err_msg_tc": "",
      "err_msg_en": "The IOTC master server is invalid"
      },
      {
      "code": 260900,
      "code_des": "任务暂停",
      "err_msg_cn": "任务暂停",
      "err_msg_tc": "",
      "err_msg_en": "Task suspension"
      },
      {
      "code": 260901,
      "code_des": "golang自带的包的错误",
      "err_msg_cn": "golang自带的包的错误",
      "err_msg_tc": "",
      "err_msg_en": "Golang bag bug"
      },
      {
      "code": 260902,
      "code_des": "P2P HTTP服务初始化失败",
      "err_msg_cn": "P2P HTTP服务初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to initialize the P2P HTTP service"
      },
      {
      "code": 260903,
      "code_des": "日志初始化失败",
      "err_msg_cn": "日志初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to initialize the log"
      },
      {
      "code": 260904,
      "code_des": "数据库初始化失败",
      "err_msg_cn": "数据库初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Database initialization failed"
      },
      {
      "code": 260905,
      "code_des": "数据库操作错误",
      "err_msg_cn": "数据库操作错误",
      "err_msg_tc": "",
      "err_msg_en": "Database operation error"
      },
      {
      "code": 260906,
      "code_des": "在数据库中找不到任务",
      "err_msg_cn": "文件不存在",
      "err_msg_tc": "",
      "err_msg_en": "File does not exist"
      },
      {
      "code": 260907,
      "code_des": "在数据库中找不到文件",
      "err_msg_cn": "在数据库中找不到文件",
      "err_msg_tc": "",
      "err_msg_en": "The file cannot be found in the database"
      },
      {
      "code": 260908,
      "code_des": "在数据库中找不到最小tutk uuid集合",
      "err_msg_cn": "在数据库中找不到最小tutk uuid集合",
      "err_msg_tc": "",
      "err_msg_en": "The minimum tutk uuid collection was not found in the database\n\n"
      },
      {
      "code": 260909,
      "code_des": "不能获取dm_cloud的服务",
      "err_msg_cn": "不能获取dm_cloud的服务",
      "err_msg_tc": "",
      "err_msg_en": "The dm_cloud service cannot be obtained"
      },
      {
      "code": 260910,
      "code_des": "没有云账号id",
      "err_msg_cn": "没有云账号id",
      "err_msg_tc": "",
      "err_msg_en": "There is no cloud account id"
      },
      {
      "code": 260911,
      "code_des": "系统盘id或路径错误",
      "err_msg_cn": "系统盘id或路径错误",
      "err_msg_tc": "",
      "err_msg_en": "The id or path of the system disk is incorrect"
      },
      {
      "code": 260912,
      "code_des": "没有权限，一般是操作了别的用户的文件会提示这个错误",
      "err_msg_cn": "没有操作权限",
      "err_msg_tc": "",
      "err_msg_en": "Have no operation permission"
      },
      {
      "code": 260913,
      "code_des": "tracker服务器错误",
      "err_msg_cn": "tracker服务器错误",
      "err_msg_tc": "",
      "err_msg_en": "Tracker error."
      },
      {
      "code": 260914,
      "code_des": "tutk服务器失败",
      "err_msg_cn": "tutk服务器失败",
      "err_msg_tc": "",
      "err_msg_en": "The tutk server failed."
      },
      {
      "code": 260915,
      "code_des": "创建协程池失败",
      "err_msg_cn": "创建协程池失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to create a coroutine pool. "
      },
      {
      "code": 260916,
      "code_des": "没有对端可供使用",
      "err_msg_cn": "没有对端可供使用",
      "err_msg_tc": "",
      "err_msg_en": "No peer is available"
      },
      {
      "code": 260917,
      "code_des": "文件下载失败",
      "err_msg_cn": "文件下载失败",
      "err_msg_tc": "",
      "err_msg_en": "File download failure"
      },
      {
      "code": 260918,
      "code_des": "任务下载失败",
      "err_msg_cn": "任务下载失败",
      "err_msg_tc": "",
      "err_msg_en": "Task download failure"
      },
      {
      "code": 260919,
      "code_des": "分片下载失败",
      "err_msg_cn": "分片下载失败",
      "err_msg_tc": "",
      "err_msg_en": "Fragment download failure"
      },
      {
      "code": 260920,
      "code_des": "计算cid失败",
      "err_msg_cn": "计算cid失败",
      "err_msg_tc": "",
      "err_msg_en": "Cid calculation failed"
      },
      {
      "code": 260921,
      "code_des": "cid校验失败",
      "err_msg_cn": "cid校验失败",
      "err_msg_tc": "",
      "err_msg_en": "Cid check failure"
      },
      {
      "code": 260922,
      "code_des": "is_dir校验失败",
      "err_msg_cn": "is_dir校验失败",
      "err_msg_tc": "",
      "err_msg_en": "Is_dir verification failed"
      },
      {
      "code": 260923,
      "code_des": "任务数过多",
      "err_msg_cn": "任务数过多",
      "err_msg_tc": "",
      "err_msg_en": "Task number overload"
      },
      {
      "code": 260924,
      "code_des": "分片下载时，临时文件不存在了",
      "err_msg_cn": "分片下载时，临时文件不存在了",
      "err_msg_tc": "",
      "err_msg_en": "The temporary file no longer exists during the sharding download"
      },
      {
      "code": 260925,
      "code_des": "磁盘空间不足",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient disk space"
      },
      {
      "code": 260926,
      "code_des": "获取磁盘信息失败",
      "err_msg_cn": "获取磁盘信息失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to obtain disk information."
      },
      {
      "code": 261100,
      "code_des": "发送到百度网盘服务器请求失败。可重试",
      "err_msg_cn": "发送到百度网盘服务器请求失败。可重试",
      "err_msg_tc": "",
      "err_msg_en": "Failed to send the request to Baidu web disk server. "
      },
      {
      "code": 261101,
      "code_des": "发送到百度网盘服务器请求失败。可重试",
      "err_msg_cn": "发送到百度网盘服务器请求失败。可重试",
      "err_msg_tc": "",
      "err_msg_en": "Failed to send the request to Baidu web disk server. "
      },
      {
      "code": 261102,
      "code_des": "内部通讯错误，可重试或重启。",
      "err_msg_cn": "内部通讯错误，可重试或重启。",
      "err_msg_tc": "",
      "err_msg_en": "Internal communication error, retry or restart."
      },
      {
      "code": 261103,
      "code_des": "本地数据库读写失败，可重试或重启。",
      "err_msg_cn": "本地数据库读写失败，可重试或重启。",
      "err_msg_tc": "",
      "err_msg_en": "Operate to the local database fails, try again or restart."
      },
      {
      "code": 261104,
      "code_des": "绑定失败，请重试",
      "err_msg_cn": "绑定失败，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Binding failed, please try again"
      },
      {
      "code": 261105,
      "code_des": "绑定失败，请重试",
      "err_msg_cn": "绑定失败，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Binding failed, please try again"
      },
      {
      "code": 261106,
      "code_des": "刷新token失败，可重试或重启。",
      "err_msg_cn": "刷新token失败，可重试或重启。",
      "err_msg_tc": "",
      "err_msg_en": "Refreshing the token fails, try again or restart."
      },
      {
      "code": 261107,
      "code_des": "登录失效，请重新登录。",
      "err_msg_cn": "登录失效，请重新登录。",
      "err_msg_tc": "",
      "err_msg_en": "Login failed, please log in again."
      },
      {
      "code": 261108,
      "code_des": "数据库操作失败，可重试或重启。",
      "err_msg_cn": "数据库操作失败，可重试或重启。",
      "err_msg_tc": "",
      "err_msg_en": "The database operation fails, try again or restart."
      },
      {
      "code": 261109,
      "code_des": "数据库初始化失败，可重试或重启。",
      "err_msg_cn": "数据库初始化失败，可重试或重启。",
      "err_msg_tc": "",
      "err_msg_en": "Database initialization failed. Try again or restart."
      },
      {
      "code": 261113,
      "code_des": "文件夹内文件上传/下载最多1000个",
      "err_msg_cn": "文件夹内文件上传/下载最多1000个",
      "err_msg_tc": "",
      "err_msg_en": "A maximum of 1000 files can be uploaded or downloaded to the folder"
      },
      {
      "code": 261114,
      "code_des": "磁盘空间不足，请重试",
      "err_msg_cn": "磁盘空间不足，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Disk space is insufficient, please try again"
      },
      {
      "code": 261115,
      "code_des": "百度网盘空间不足，请重试。",
      "err_msg_cn": "百度网盘空间不足，请重试。",
      "err_msg_tc": "",
      "err_msg_en": "Baidu web disk space is insufficient, please try again."
      },
      {
      "code": 261117,
      "code_des": "请先同意在您的百度网盘创建文件夹并读写数据",
      "err_msg_cn": "请先同意在您的百度网盘创建文件夹并读写数据",
      "err_msg_tc": "",
      "err_msg_en": "Please first agree to create folders and read and write data in your Baidu web disk"
      },
      {
      "code": 261118,
      "code_des": "任务数不能为0",
      "err_msg_cn": "任务数不能为0",
      "err_msg_tc": "",
      "err_msg_en": "The number of tasks cannot be 0"
      },
      {
      "code": 261119,
      "code_des": "开始备份任务失败",
      "err_msg_cn": "开始备份任务失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to start a backup job. "
      },
      {
      "code": 261120,
      "code_des": "暂停备份任务失败",
      "err_msg_cn": "暂停备份任务失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to stop a backup job. "
      },
      {
      "code": 261121,
      "code_des": "删除备份任务失败",
      "err_msg_cn": "删除备份任务失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to delete a backup job. "
      },
      {
      "code": 261122,
      "code_des": "此文件夹已经自动备份至百度网盘",
      "err_msg_cn": "此文件夹已经自动备份至百度网盘",
      "err_msg_tc": "",
      "err_msg_en": "This folder has been automatically backed up to Baidu web disk"
      },
      {
      "code": 261123,
      "code_des": "最多创建10个自动备份任务",
      "err_msg_cn": "最多创建10个自动备份任务",
      "err_msg_tc": "",
      "err_msg_en": "A maximum of 10 automatic backup jobs can be created"
      },
      {
      "code": 261150,
      "code_des": "发送到百度服务器的参数错误",
      "err_msg_cn": "发送到百度服务器的参数错误",
      "err_msg_tc": "",
      "err_msg_en": "Parameter error sent to Baidu server"
      },
      {
      "code": 261151,
      "code_des": "身份验证失败",
      "err_msg_cn": "身份验证失败",
      "err_msg_tc": "",
      "err_msg_en": "Authentication failure"
      },
      {
      "code": 261152,
      "code_des": "目录已存在",
      "err_msg_cn": "目录已存在",
      "err_msg_tc": "",
      "err_msg_en": "Directory already exists"
      },
      {
      "code": 261153,
      "code_des": "文件或目录无权限访问",
      "err_msg_cn": "文件或目录无权限访问",
      "err_msg_tc": "",
      "err_msg_en": "The file or directory is not accessible"
      },
      {
      "code": 261154,
      "code_des": "文件或目录不存在",
      "err_msg_cn": "文件或目录不存在",
      "err_msg_tc": "",
      "err_msg_en": "The file or directory does not exist"
      },
      {
      "code": 261155,
      "code_des": "上传失败，请重试",
      "err_msg_cn": "上传失败，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Upload failed, please try again\n\n"
      },
      {
      "code": 261156,
      "code_des": "上传失败，请重试",
      "err_msg_cn": "上传失败，请重试",
      "err_msg_tc": "",
      "err_msg_en": "Upload failed, please try again\n\n"
      },
      {
      "code": 261157,
      "code_des": "触发百度服务器请求限制，请稍候重试",
      "err_msg_cn": "触发百度服务器请求限制，请稍候重试",
      "err_msg_tc": "",
      "err_msg_en": "Baidu server request limit triggered, please try again later"
      },
      {
      "code": 261158,
      "code_des": "访问过于频繁，请稍后重试",
      "err_msg_cn": "访问过于频繁，请稍后重试",
      "err_msg_tc": "",
      "err_msg_en": "Too frequent access, please try again later"
      },
      {
      "code": 261159,
      "code_des": "rand校验失败，请稍后重试",
      "err_msg_cn": "rand校验失败，请稍后重试",
      "err_msg_tc": "",
      "err_msg_en": "The rand check failed. Please try again later\n\n"
      },
      {
      "code": 261160,
      "code_des": "功能已下线，如有疑问，请联系客服人员",
      "err_msg_cn": "功能已下线，如有疑问，请联系客服人员",
      "err_msg_tc": "",
      "err_msg_en": "Function has been offline, if in doubt, please contact customer service staff"
      },
      {
      "code": 261161,
      "code_des": "账号被封禁，请联系百度客服",
      "err_msg_cn": "账号被封禁，请联系百度客服",
      "err_msg_tc": "",
      "err_msg_en": "Account is blocked, please contact Baidu customer service"
      },
      {
      "code": 261162,
      "code_des": "账号被封禁，请联系百度客服",
      "err_msg_cn": "账号被封禁，请联系百度客服",
      "err_msg_tc": "",
      "err_msg_en": "Account is blocked, please contact Baidu customer service"
      },
      {
      "code": 261163,
      "code_des": "账号被封禁，请联系百度客服",
      "err_msg_cn": "账号被封禁，请联系百度客服",
      "err_msg_tc": "",
      "err_msg_en": "Account is blocked, please contact Baidu customer service"
      },
      {
      "code": 261164,
      "code_des": "账号被封禁，请联系百度客服",
      "err_msg_cn": "账号被封禁，请联系百度客服",
      "err_msg_tc": "",
      "err_msg_en": "Account is blocked, please contact Baidu customer service"
      },
      {
      "code": 261165,
      "code_des": "账号被封禁，请联系百度客服",
      "err_msg_cn": "账号被封禁，请联系百度客服",
      "err_msg_tc": "",
      "err_msg_en": "Account is blocked, please contact Baidu customer service"
      },
      {
      "code": 261166,
      "code_des": "查询用户信息失败，可重试",
      "err_msg_cn": "查询用户信息失败，可重试",
      "err_msg_tc": "",
      "err_msg_en": "Failed to query user information. Try again"
      },
      {
      "code": 261167,
      "code_des": "您当前没有上传权限",
      "err_msg_cn": "您当前没有上传权限",
      "err_msg_tc": "",
      "err_msg_en": "You currently do not have upload permission"
      },
      {
      "code": 261200,
      "code_des": "迅雷插件状态请求失败",
      "err_msg_cn": "迅雷插件状态请求失败",
      "err_msg_tc": "",
      "err_msg_en": "The Thunderbolt plugin status request failed. "
      },
      {
      "code": 261201,
      "code_des": "迅雷插件转换路径失败",
      "err_msg_cn": "迅雷插件转换路径失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to convert the path of the Thunderbolt plugin"
      },
      {
      "code": 261202,
      "code_des": "迅雷账号解绑失败",
      "err_msg_cn": "迅雷账号解绑失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to unbind the thunderbolt account"
      },
      {
      "code": 261400,
      "code_des": "任务暂停",
      "err_msg_cn": "任务暂停",
      "err_msg_tc": "",
      "err_msg_en": "Task suspension"
      },
      {
      "code": 261401,
      "code_des": "golang自带的包的错误",
      "err_msg_cn": "golang自带的包的错误",
      "err_msg_tc": "",
      "err_msg_en": "Golang bag bug"
      },
      {
      "code": 261402,
      "code_des": "utils初始化失败",
      "err_msg_cn": "utils初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to initialize utils"
      },
      {
      "code": 261403,
      "code_des": "DEVICEMGR HTTP服务初始化失败",
      "err_msg_cn": "DEVICEMGR HTTP服务初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "The DEVICEMGR HTTP service fails to be initialized"
      },
      {
      "code": 261404,
      "code_des": "日志初始化失败",
      "err_msg_cn": "日志初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to initialize the log"
      },
      {
      "code": 261405,
      "code_des": "数据库初始化失败",
      "err_msg_cn": "数据库初始化失败",
      "err_msg_tc": "",
      "err_msg_en": "Database initialization failed"
      },
      {
      "code": 261406,
      "code_des": "数据库操作错误",
      "err_msg_cn": "数据库操作错误",
      "err_msg_tc": "",
      "err_msg_en": "Database operation error"
      },
      {
      "code": 261407,
      "code_des": "在数据库中找不到任务",
      "err_msg_cn": "在数据库中找不到任务",
      "err_msg_tc": "",
      "err_msg_en": "The task cannot be found in the database"
      },
      {
      "code": 261408,
      "code_des": "在数据库中找不到文件",
      "err_msg_cn": "在数据库中找不到文件",
      "err_msg_tc": "",
      "err_msg_en": "The file cannot be found in the database"
      },
      {
      "code": 261409,
      "code_des": "在数据库中找不到最小tutk uuid集合",
      "err_msg_cn": "在数据库中找不到最小tutk uuid集合",
      "err_msg_tc": "",
      "err_msg_en": "The minimum tutk uuid collection was not found in the database"
      },
      {
      "code": 261410,
      "code_des": "不能获取dm_cloud的服务",
      "err_msg_cn": "不能获取dm_cloud的服务",
      "err_msg_tc": "",
      "err_msg_en": "The dm_cloud service cannot be obtained"
      },
      {
      "code": 261411,
      "code_des": "没有云账号id",
      "err_msg_cn": "没有云账号id",
      "err_msg_tc": "",
      "err_msg_en": "There is no cloud account id"
      },
      {
      "code": 261412,
      "code_des": "系统盘id或路径错误",
      "err_msg_cn": "系统盘id或路径错误",
      "err_msg_tc": "",
      "err_msg_en": "The id or path of the system disk is incorrect"
      },
      {
      "code": 261413,
      "code_des": "没有权限，一般是操作了别的用户的文件会提示这个错误",
      "err_msg_cn": "没有操作权限",
      "err_msg_tc": "",
      "err_msg_en": "No operation permission"
      },
      {
      "code": 261414,
      "code_des": "tracker服务器错误",
      "err_msg_cn": "tracker服务器错误",
      "err_msg_tc": "",
      "err_msg_en": "Tracker error."
      },
      {
      "code": 261415,
      "code_des": "tutk服务器失败",
      "err_msg_cn": "tutk服务器失败",
      "err_msg_tc": "",
      "err_msg_en": "Tutk error"
      },
      {
      "code": 261416,
      "code_des": "创建协程池失败",
      "err_msg_cn": "创建协程池失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to create a coroutine pool."
      },
      {
      "code": 261417,
      "code_des": "没有对端可供使用",
      "err_msg_cn": "没有对端可供使用",
      "err_msg_tc": "",
      "err_msg_en": "No peer is available"
      },
      {
      "code": 261418,
      "code_des": "文件下载失败",
      "err_msg_cn": "文件下载失败",
      "err_msg_tc": "",
      "err_msg_en": "File download failure"
      },
      {
      "code": 261419,
      "code_des": "任务下载失败",
      "err_msg_cn": "任务下载失败",
      "err_msg_tc": "",
      "err_msg_en": "Task download failure"
      },
      {
      "code": 261420,
      "code_des": "分片下载失败",
      "err_msg_cn": "分片下载失败",
      "err_msg_tc": "",
      "err_msg_en": "Fragment download failure"
      },
      {
      "code": 261421,
      "code_des": "计算cid失败",
      "err_msg_cn": "计算cid失败",
      "err_msg_tc": "",
      "err_msg_en": "Cid calculation failed"
      },
      {
      "code": 261422,
      "code_des": "cid校验失败",
      "err_msg_cn": "cid校验失败",
      "err_msg_tc": "",
      "err_msg_en": "Cid check failure"
      },
      {
      "code": 261423,
      "code_des": "is_dir校验失败",
      "err_msg_cn": "is_dir校验失败",
      "err_msg_tc": "",
      "err_msg_en": "Is_dir verification fails"
      },
      {
      "code": 261424,
      "code_des": "任务数过多",
      "err_msg_cn": "任务数过多",
      "err_msg_tc": "",
      "err_msg_en": "Task number overload"
      },
      {
      "code": 261425,
      "code_des": "分片下载时，临时文件不存在了",
      "err_msg_cn": "分片下载时，临时文件不存在了",
      "err_msg_tc": "",
      "err_msg_en": "The temporary file no longer exists during the sharding download"
      },
      {
      "code": 261426,
      "code_des": "服务没有初始化",
      "err_msg_cn": "服务没有初始化",
      "err_msg_tc": "",
      "err_msg_en": "The service is not initialized"
      },
      {
      "code": 261427,
      "code_des": "磁盘空间不足",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient disk space"
      },
      {
      "code": 261428,
      "code_des": "获取磁盘信息失败",
      "err_msg_cn": "获取磁盘信息失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to obtain disk information."
      },
      {
      "code": 261501,
      "code_des": "执行命令失败",
      "err_msg_cn": "执行命令失败",
      "err_msg_tc": "",
      "err_msg_en": "Command execution failure"
      },
      {
      "code": 261502,
      "code_des": "非法命令",
      "err_msg_cn": "非法命令",
      "err_msg_tc": "",
      "err_msg_en": "Illegal command"
      },
      {
      "code": 261503,
      "code_des": "磁盘空间不足",
      "err_msg_cn": "磁盘空间不足",
      "err_msg_tc": "",
      "err_msg_en": "Insufficient disk space"
      },
      {
      "code": 261504,
      "code_des": "日志正在上传",
      "err_msg_cn": "日志正在上传",
      "err_msg_tc": "",
      "err_msg_en": "Log uploading"
      },
      {
      "code": 261505,
      "code_des": "ping不通日志服务器",
      "err_msg_cn": "ping不通日志服务器",
      "err_msg_tc": "",
      "err_msg_en": "Cannot ping the log server "
      },
      {
      "code": 261506,
      "code_des": "获取设备信息失败",
      "err_msg_cn": "获取设备信息失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to obtain device information"
      },
      {
      "code": 261507,
      "code_des": "日志路径不存在",
      "err_msg_cn": "日志路径不存在",
      "err_msg_tc": "",
      "err_msg_en": "The log path does not exist"
      },
      {
      "code": 261508,
      "code_des": "压缩加密日志失败",
      "err_msg_cn": "压缩加密日志失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to compress and encrypt logs"
      },
      {
      "code": 261509,
      "code_des": "上传日志到服务器失败",
      "err_msg_cn": "上传日志到服务器失败",
      "err_msg_tc": "",
      "err_msg_en": "Failed to upload logs to the server"
      },
      {
      "code": 261510,
      "code_des": "dm_cloud错误",
      "err_msg_cn": "dm_cloud错误",
      "err_msg_tc": "",
      "err_msg_en": "dm_cloud error"
      },
      {
      "code": 261700,
      "code_des": "当前固件版本已经是最新, 没有可升级固件版本",
      "err_msg_cn": "当前固件版本已经是最新, 没有可升级固件版本",
      "err_msg_tc": "",
      "err_msg_en": "The current firmware version is the latest one, and no firmware version can be upgraded"
      },
      {
      "code": 261800,
      "code_des": "任务取消",
      "err_msg_cn": "任务取消",
      "err_msg_tc": "",
      "err_msg_en": "Task cancellation"
      },
      {
      "code": 261801,
      "code_des": "go包的错误",
      "err_msg_cn": "go包的错误",
      "err_msg_tc": "",
      "err_msg_en": "Go bag error"
      },
      {
      "code": 261802,
      "code_des": "数据库错误",
      "err_msg_cn": "数据库错误",
      "err_msg_tc": "",
      "err_msg_en": "Database error"
      },
      {
      "code": 261803,
      "code_des": "dm_cloud接口错误",
      "err_msg_cn": "dm_cloud接口错误",
      "err_msg_tc": "",
      "err_msg_en": "dm_cloud interface failed. "
      },
      {
      "code": 261804,
      "code_des": "系统盘id或路径错误",
      "err_msg_cn": "系统盘id或路径错误",
      "err_msg_tc": "",
      "err_msg_en": "The id or path of the system disk is incorrect"
      },
      {
      "code": 261805,
      "code_des": "服务已被其他用户占用",
      "err_msg_cn": "服务已被其他用户占用",
      "err_msg_tc": "",
      "err_msg_en": "The service is occupied by another user"
      },
      {
      "code": 261806,
      "code_des": "用户已经有一个去重任务了",
      "err_msg_cn": "用户已经有一个去重任务了",
      "err_msg_tc": "",
      "err_msg_en": "The user already has a deduplicate task"
      },
      {
      "code": 261807,
      "code_des": "找不到任务",
      "err_msg_cn": "找不到任务",
      "err_msg_tc": "",
      "err_msg_en": "Can't find the task"
      },
      {
      "code": 261808,
      "code_des": "cid生成失败",
      "err_msg_cn": "cid生成失败",
      "err_msg_tc": "",
      "err_msg_en": "Cid generation failure"
      },
      {
      "code": 261900,
      "code_des": "不支持的文件格式",
      "err_msg_cn": "不支持的文件格式",
      "err_msg_tc": "",
      "err_msg_en": "Unsupported file format"
      },
      {
      "code": 900001,
      "code_des": "设备通信异常",
      "err_msg_cn": "设备通信异常",
      "err_msg_tc": "",
      "err_msg_en": "Device communication exception"
      }
      ]
      }



// WEBPACK FOOTER //
// ./src/utils/errorCode.js